const AllGeneList = [
"A4GALT",
"A4GNT",
"AACS",
"AADAT",
"AAK1",
"AAMP",
"AANAT",
"AAR2",
"AARD",
"AARS2",
"AARSD1",
"AASDH",
"AATBC",
"AATF",
"ABAT",
"ABCA1",
"ABCA5",
"ABCB6",
"ABCC1",
"ABCC10",
"ABCC2",
"ABCC3",
"ABCC5-AS1",
"ABCC6",
"ABCD3",
"ABCF2",
"ABCG2",
"ABCG5",
"ABCG8",
"ABHD1",
"ABHD10",
"ABHD11",
"ABHD11-AS1",
"ABHD12",
"ABHD12B",
"ABHD15",
"ABHD16A",
"ABHD17C",
"ABHD2",
"ABHD3",
"ABHD4",
"ABHD5",
"ABI2",
"ABI3BP",
"ABL1",
"ABL2",
"ABLIM1",
"ABO",
"ABR",
"ABRA",
"ABRACL",
"ABT1",
"ABTB1",
"ABTB2",
"ACAD11",
"ACADM",
"ACAP2",
"ACAT2",
"ACBD5",
"ACBD6",
"ACER2",
"ACER3",
"ACKR3",
"ACLY",
"ACMSD",
"ACOT11",
"ACOT2",
"ACOT4",
"ACOT9",
"ACOXL",
"ACPT",
"ACRC",
"ACRV1",
"ACSF2",
"ACSL3",
"ACSL4",
"ACSL5",
"ACSM4",
"ACSM6",
"ACTA2",
"ACTG1",
"ACTL6A",
"ACTL6B",
"ACTL7B",
"ACTL8",
"ACTN1-AS1",
"ACTR2",
"ACTR3B",
"ACTR5",
"ACVR1",
"ACVR2A",
"ACYP2",
"ADAM17",
"ADAM1A",
"ADAM21",
"ADAM8",
"ADAMTS13",
"ADAMTS19-AS1",
"ADAMTS6",
"ADAMTSL4",
"ADAMTSL4-AS1",
"ADAP1",
"ADAP2",
"ADARB1",
"ADARB2",
"ADARB2-AS1",
"ADAT2",
"ADCY10",
"ADCY3",
"ADCY4",
"ADCY9",
"ADD2",
"ADD3",
"ADGRA3",
"ADGRB1",
"ADGRG2",
"ADGRL1",
"ADGRV1",
"ADH4",
"ADH6",
"ADH7",
"ADI1",
"ADIPOR2",
"ADIRF",
"ADNP2",
"ADO",
"ADORA1",
"ADORA2B",
"ADPRH",
"ADRA1B",
"ADRA1D",
"ADRA2C",
"ADRB1",
"ADRB2",
"ADRBK1",
"ADRM1",
"ADTRP",
"AFF1",
"AFTPH",
"AGA",
"AGBL3",
"AGFG1",
"AGGF1",
"AGK",
"AGL",
"AGO2",
"AGO3",
"AGPAT3",
"AGPAT4",
"AGPAT5",
"AGRP",
"AGTPBP1",
"AHCYL1",
"AHDC1",
"AHNAK",
"AHSA1",
"AHSA2",
"AIG1",
"AK5",
"AKAP1",
"AKAP10",
"AKAP11",
"AKAP14",
"AKAP3",
"AKAP5",
"AKAP7",
"AKAP8",
"AKIRIN1",
"AKIRIN2",
"AKR1A1",
"AKR1B1",
"AKR1C1",
"AKR1C4",
"AKR1C6P",
"AKR1D1",
"AKR7L",
"AKTIP",
"ALAS2",
"ALCAM",
"ALDH1A3",
"ALDH1L2",
"ALDH2",
"ALDH3A1",
"ALDH3B1",
"ALDH7A1",
"ALDH8A1",
"ALDOC",
"ALG10",
"ALG13",
"ALG14",
"ALG1L",
"ALG1L9P",
"ALKBH5",
"ALKBH6",
"ALMS1",
"ALMS1P",
"ALOX12",
"ALOX12B",
"ALOX15P1",
"ALOXE3",
"ALPK1",
"ALPK3",
"ALS2CL",
"ALX4",
"AMER1",
"AMFR",
"AMMECR1",
"AMMECR1L",
"AMOTL1",
"AMOTL2",
"AMPD2",
"AMZ1",
"AMZ2",
"AMZ2P1",
"ANAPC1",
"ANAPC13",
"ANAPC16",
"ANAPC1P1",
"ANAPC4",
"ANAPC7",
"ANG",
"ANGPT2",
"ANGPT4",
"ANGPTL4",
"ANGPTL6",
"ANKDD1B",
"ANKH",
"ANKHD1",
"ANKIB1",
"ANKRD10",
"ANKRD11",
"ANKRD13B",
"ANKRD16",
"ANKRD17",
"ANKRD18A",
"ANKRD18B",
"ANKRD20A11P",
"ANKRD20A19P",
"ANKRD26P1",
"ANKRD28",
"ANKRD31",
"ANKRD36B",
"ANKRD36BP1",
"ANKRD37",
"ANKRD40",
"ANKRD42",
"ANKRD44",
"ANKRD46",
"ANKRD52",
"ANKRD53",
"ANKRD9",
"ANKS1B",
"ANKS6",
"ANO6",
"ANO9",
"ANP32A",
"ANP32AP1",
"ANP32B",
"ANP32E",
"ANPEP",
"ANTXRL",
"ANXA2",
"ANXA3",
"ANXA4",
"ANXA5",
"ANXA9",
"AP1AR",
"AP1G1",
"AP1M2",
"AP1S2",
"AP1S3",
"AP2A1",
"AP3B1",
"AP3M2",
"AP3S2",
"AP4S1",
"AP5S1",
"AP5Z1",
"APBA2",
"APC2",
"APCS",
"APEX1",
"APIP",
"APOA1BP",
"APOA4",
"APOA5",
"APOBEC2",
"APOBEC3B-AS1",
"APOL1",
"APOL2",
"APOL6",
"APTR",
"APTX",
"AQP11",
"AQP7P3",
"AQP9",
"AR",
"ARAF",
"ARAP2",
"AREG",
"ARF1",
"ARF4",
"ARF6",
"ARFGAP2",
"ARFGAP3",
"ARFGEF1",
"ARFGEF3",
"ARG1",
"ARGFXP2",
"ARGLU1",
"ARHGAP11B",
"ARHGAP17",
"ARHGAP18",
"ARHGAP21",
"ARHGAP24",
"ARHGAP27",
"ARHGAP30",
"ARHGAP31-AS1",
"ARHGAP35",
"ARHGAP42",
"ARHGAP6",
"ARHGDIA",
"ARHGEF10L",
"ARHGEF12",
"ARHGEF17",
"ARHGEF19",
"ARHGEF28",
"ARHGEF33",
"ARHGEF37",
"ARHGEF38",
"ARHGEF5",
"ARID1A",
"ARID1B",
"ARID2",
"ARID3A",
"ARID3B",
"ARID4B",
"ARID5B",
"ARIH1",
"ARL10",
"ARL11",
"ARL13A",
"ARL14EP",
"ARL15",
"ARL17A",
"ARL17B",
"ARL2BP",
"ARL4A",
"ARL4C",
"ARL4D",
"ARL5B",
"ARL6",
"ARMC5",
"ARMC7",
"ARMC9",
"ARMT1",
"ARNT2",
"ARNTL",
"ARNTL2",
"ARNTL2-AS1",
"ARPC2",
"ARPC5",
"ARPC5L",
"ARPP19",
"ARR3",
"ARRB1",
"ARRDC3-AS1",
"ARRDC4",
"ARSE",
"ARSG",
"ARSJ",
"ART4",
"ARTN",
"ARV1",
"ASAH1",
"ASAH2B",
"ASAP1",
"ASB1",
"ASB13",
"ASB15",
"ASB16-AS1",
"ASB17",
"ASB7",
"ASCC1",
"ASCC2",
"ASCL2",
"ASCL5",
"ASF1A",
"ASF1B",
"ASH2L",
"ASIP",
"ASNA1",
"ASPN",
"ASTL",
"ASXL1",
"ATAD5",
"ATE1-AS1",
"ATF1",
"ATF3",
"ATF4",
"ATF6",
"ATF7IP2",
"ATG10",
"ATG16L1",
"ATG16L2",
"ATG3",
"ATG4C",
"ATG5",
"ATOX1",
"ATP11A",
"ATP11C",
"ATP13A3",
"ATP1B3",
"ATP2A1-AS1",
"ATP2A2",
"ATP2A3",
"ATP2B1",
"ATP2C2",
"ATP4A",
"ATP4B",
"ATP5B",
"ATP5G1",
"ATP5G2",
"ATP5G3",
"ATP5J",
"ATP5J2-PTCD1",
"ATP5O",
"ATP6AP2",
"ATP6V0D2",
"ATP6V0E1",
"ATP6V1B1",
"ATP6V1B2",
"ATP6V1C1",
"ATP6V1E2",
"ATP6V1H",
"ATP7B",
"ATP8B1",
"ATP8B4",
"ATP9A",
"ATPAF1",
"ATPIF1",
"ATRN",
"ATXN1",
"ATXN10",
"ATXN1L",
"ATXN2",
"ATXN7L3B",
"AURKAIP1",
"AVPI1",
"AZIN1",
"AZIN2",
"AZU1",
"B2M",
"B3GALNT2",
"B3GALT5",
"B3GLCT",
"B3GNT2",
"B3GNT7",
"B3GNT8",
"B4GALT3",
"B4GALT5",
"B4GALT6",
"B4GALT7",
"BAALC",
"BAG3",
"BAGE2",
"BAHCC1",
"BAIAP2",
"BAIAP2L2",
"BAMBI",
"BANP",
"BARD1",
"BARHL1",
"BARX1",
"BASP1",
"BATF",
"BATF2",
"BAZ1A",
"BAZ1B",
"BBS1",
"BBS2",
"BBX",
"BCAN",
"BCAP29",
"BCAS1",
"BCAS2",
"BCAS4",
"BCL2L13",
"BCL2L14",
"BCL2L15",
"BCL2L2",
"BCL3",
"BCL6",
"BCL7C",
"BCL9",
"BCO1",
"BCR",
"BCYRN1",
"BDKRB1",
"BDKRB2",
"BEND3",
"BEND3P3",
"BEND7",
"BEST2",
"BET1",
"BHLHB9",
"BHLHE40",
"BHLHE40-AS1",
"BHLHE41",
"BICC1",
"BICD1",
"BICD2",
"BIN3",
"BIRC2",
"BIRC3",
"BIRC6",
"BLACAT1",
"BLMH",
"BLOC1S6",
"BMP2",
"BMP2K",
"BMP5",
"BMP7",
"BMP8A",
"BMP8B",
"BMPR1A",
"BMPR2",
"BMS1P18",
"BMS1P20",
"BMS1P5",
"BNC1",
"BNIP1",
"BNIP3L",
"BNIPL",
"BOLA2B",
"BOLA3",
"BOLL",
"BPGM",
"BPIFB1",
"BRAF",
"BRAP",
"BRCA1",
"BRD1",
"BRD7",
"BRI3",
"BRMS1L",
"BRPF3",
"BRWD1",
"BRWD1-AS1",
"BSDC1",
"BST2",
"BTAF1",
"BTBD16",
"BTBD18",
"BTBD3",
"BTF3",
"BTG2",
"BTN1A1",
"BTNL10",
"BTRC",
"BUB1",
"BUB3",
"BUD13",
"BZW2",
"C10orf111",
"C10orf55",
"C10orf67",
"C10orf76",
"C10orf88",
"C11orf24",
"C11orf30",
"C11orf58",
"C11orf73",
"C11orf80",
"C11orf84",
"C11orf91",
"C12orf29",
"C12orf4",
"C12orf49",
"C12orf50",
"C12orf65",
"C12orf66",
"C12orf71",
"C12orf79",
"C14orf105",
"C14orf159",
"C14orf2",
"C15orf27",
"C15orf39",
"C15orf40",
"C15orf52",
"C15orf54",
"C15orf61",
"C16orf13",
"C16orf58",
"C16orf70",
"C16orf72",
"C16orf74",
"C16orf89",
"C16orf90",
"C16orf95",
"C17orf104",
"C17orf105",
"C17orf53",
"C17orf67",
"C17orf78",
"C17orf85",
"C17orf96",
"C17orf98",
"C18orf21",
"C18orf25",
"C19orf12",
"C19orf43",
"C19orf53",
"C19orf67",
"C1GALT1",
"C1orf100",
"C1orf105",
"C1orf106",
"C1orf116",
"C1orf159",
"C1orf162",
"C1orf177",
"C1orf195",
"C1orf21",
"C1orf216",
"C1orf53",
"C1orf54",
"C1orf61",
"C1orf95",
"C1QL3",
"C1QTNF1-AS1",
"C1QTNF2",
"C1QTNF5",
"C1QTNF7",
"C20orf141",
"C20orf62",
"C21orf91",
"C22orf23",
"C22orf39",
"C2CD2",
"C2CD5",
"C2orf27A",
"C2orf42",
"C2orf49",
"C2orf54",
"C2orf57",
"C2orf69",
"C2orf74",
"C2orf78",
"C2orf83",
"C3orf14",
"C3orf17",
"C3orf30",
"C3orf33",
"C3orf35",
"C3orf38",
"C3orf58",
"C3orf62",
"C3orf67",
"C3orf67-AS1",
"C3orf79",
"C3orf80",
"C4orf19",
"C4orf3",
"C4orf36",
"C4orf47",
"C4orf48",
"C4orf51",
"C5orf24",
"C5orf28",
"C5orf30",
"C5orf34",
"C5orf49",
"C5orf56",
"C5orf60",
"C5orf63",
"C5orf66",
"C6orf1",
"C6orf106",
"C6orf132",
"C6orf163",
"C6orf226",
"C6orf229",
"C7orf50",
"C7orf55-LUC7L2",
"C7orf60",
"C7orf61",
"C7orf71",
"C7orf73",
"C8G",
"C8orf37",
"C8orf4",
"C8orf59",
"C9orf117",
"C9orf131",
"C9orf142",
"C9orf152",
"C9orf156",
"C9orf163",
"C9orf171",
"C9orf3",
"C9orf41-AS1",
"C9orf57",
"C9orf64",
"C9orf69",
"C9orf84",
"C9orf85",
"CA1",
"CA5A",
"CA5B",
"CA5BP1",
"CA7",
"CAAP1",
"CABLES1",
"CABP1",
"CABP4",
"CACNA2D4",
"CACNB3",
"CACNB4",
"CACNG1",
"CACNG4",
"CACNG8",
"CACUL1",
"CAD",
"CADM4",
"CAHM",
"CALCOCO2",
"CALHM1",
"CALM1",
"CALML3-AS1",
"CALML5",
"CALR",
"CALU",
"CAMK1",
"CAMK1D",
"CAMK1G",
"CAMK2D",
"CAMK2N1",
"CAMK4",
"CAMKK2",
"CAMKMT",
"CAMKV",
"CAMSAP1",
"CAMTA1",
"CAND1",
"CAND1.11",
"CAND2",
"CANX",
"CAP1",
"CAPN13",
"CAPN2",
"CAPN3",
"CAPN8",
"CAPRIN1",
"CAPRIN2",
"CAPZA2",
"CARD10",
"CARD6",
"CARD8",
"CARF",
"CARHSP1",
"CARS",
"CARS2",
"CASC10",
"CASC19",
"CASC21",
"CASC23",
"CASC3",
"CASC4",
"CASC5",
"CASC8",
"CASC9",
"CASK",
"CASP16P",
"CASP7",
"CAST",
"CAT",
"CATIP-AS2",
"CATSPER2",
"CATSPER3",
"CATSPERB",
"CATSPERG",
"CAV1",
"CAV2",
"CBFA2T3",
"CBFB",
"CBLL1",
"CBR4",
"CBS",
"CBWD2",
"CBWD5",
"CBX1",
"CBX2",
"CBX4",
"CBX8",
"CBY1",
"CCAR1",
"CCAT1",
"CCBE1",
"CCDC106",
"CCDC109B",
"CCDC116",
"CCDC117",
"CCDC120",
"CCDC122",
"CCDC124",
"CCDC125",
"CCDC130",
"CCDC14",
"CCDC146",
"CCDC153",
"CCDC158",
"CCDC162P",
"CCDC166",
"CCDC17",
"CCDC170",
"CCDC171",
"CCDC174",
"CCDC181",
"CCDC185",
"CCDC186",
"CCDC25",
"CCDC30",
"CCDC42B",
"CCDC43",
"CCDC47",
"CCDC57",
"CCDC58",
"CCDC59",
"CCDC6",
"CCDC64",
"CCDC64B",
"CCDC65",
"CCDC7",
"CCDC73",
"CCDC80",
"CCDC81",
"CCDC88A",
"CCDC88C",
"CCDC90B",
"CCDC91",
"CCDC93",
"CCDC94",
"CCL19",
"CCL21",
"CCL28",
"CCL3L1",
"CCL5",
"CCNA1",
"CCNB1",
"CCND1",
"CCNE1",
"CCNG2",
"CCNH",
"CCNI",
"CCNJ",
"CCNL1",
"CCNO",
"CCNT1",
"CCNY",
"CCNYL1",
"CCR1",
"CCR10",
"CCR7",
"CCT4",
"CCT6B",
"CCT6P3",
"CD109",
"CD160",
"CD200R1L",
"CD226",
"CD247",
"CD248",
"CD27-AS1",
"CD2AP",
"CD2BP2",
"CD300A",
"CD300E",
"CD44",
"CD46",
"CD47",
"CD5",
"CD53",
"CD55",
"CD70",
"CD74",
"CD81-AS1",
"CD82",
"CD83",
"CD8B",
"CD9",
"CDC123",
"CDC14B",
"CDC25B",
"CDC27",
"CDC34",
"CDC37L1-AS1",
"CDC40",
"CDC42EP2",
"CDC42EP3",
"CDC42SE2",
"CDC5L",
"CDC6",
"CDC7",
"CDCA2",
"CDCA4",
"CDCA5",
"CDCA7",
"CDCP1",
"CDH13",
"CDH23",
"CDH26",
"CDH3",
"CDK1",
"CDK12",
"CDK13",
"CDK14",
"CDK15",
"CDK17",
"CDK18",
"CDK19",
"CDK2AP1",
"CDK2AP2",
"CDK5R2",
"CDK5RAP1",
"CDK5RAP3",
"CDK8",
"CDKL1",
"CDKL2",
"CDKL4",
"CDKN1B",
"CDKN2AIP",
"CDKN2AIPNL",
"CDKN2B-AS1",
"CDKN2C",
"CDKN3",
"CDR1",
"CDR2",
"CDRT15",
"CDS1",
"CDT1",
"CEACAM1",
"CEACAM16",
"CEACAM19",
"CEACAM3",
"CEACAM5",
"CEACAM6",
"CEACAM7",
"CEBPA",
"CEBPG",
"CECR5",
"CECR7",
"CELF1",
"CELF4",
"CEMIP",
"CENPBD1P1",
"CENPC",
"CENPE",
"CENPH",
"CENPN",
"CEP128",
"CEP152",
"CEP164",
"CEP170B",
"CEP350",
"CEP44",
"CEP57L1",
"CEP70",
"CEP72",
"CEP76",
"CEP85",
"CEP89",
"CERS2",
"CES1P1",
"CETN2",
"CETN3",
"CETP",
"CFAP126",
"CFAP36",
"CFAP43",
"CFAP44-AS1",
"CFAP45",
"CFAP52",
"CFAP97",
"CFD",
"CFL2",
"CFLAR",
"CGRRF1",
"CHAC1",
"CHAF1B",
"CHAMP1",
"CHCHD1",
"CHCHD2",
"CHCHD7",
"CHD1",
"CHD2",
"CHD3",
"CHD4",
"CHD6",
"CHD7",
"CHD8",
"CHD9",
"CHGA",
"CHIC1",
"CHIC2",
"CHKA",
"CHM",
"CHML",
"CHMP2B",
"CHMP4C",
"CHMP6",
"CHN1",
"CHN2",
"CHORDC1",
"CHPF2",
"CHPT1",
"CHRAC1",
"CHRDL2",
"CHRM1",
"CHRM5",
"CHRNA5",
"CHRNB1",
"CHRNB2",
"CHRND",
"CHST2",
"CHST6",
"CHST7",
"CHSY1",
"CHSY3",
"CIB1",
"CIDEA",
"CIDEC",
"CIPC",
"CISD1",
"CISH",
"CITED2",
"CIZ1",
"CKAP2",
"CKAP2L",
"CKAP4",
"CKB",
"CKM",
"CKMT2",
"CLCN3",
"CLCNKB",
"CLDN11",
"CLDN14",
"CLDN15",
"CLDN16",
"CLDN18",
"CLDN19",
"CLDN20",
"CLDN3",
"CLDN4",
"CLDN9",
"CLDND1",
"CLDND2",
"CLEC16A",
"CLEC18A",
"CLEC18C",
"CLEC4A",
"CLHC1",
"CLIC4",
"CLIP1",
"CLIP1-AS1",
"CLIP3",
"CLK4",
"CLMP",
"CLN3",
"CLN5",
"CLN6",
"CLN8",
"CLOCK",
"CLPTM1L",
"CLPX",
"CLRN1",
"CLSTN1",
"CLSTN2",
"CLTA",
"CLTC",
"CLUH",
"CMAS",
"CMC1",
"CMC4",
"CMPK1",
"CMSS1",
"CMTM2",
"CMTM4",
"CMTM6",
"CMTM8",
"CMYA5",
"CNBD2",
"CNBP",
"CNGA1",
"CNGA4",
"CNGB3",
"CNIH1",
"CNIH3",
"CNKSR2",
"CNKSR3",
"CNN1",
"CNOT11",
"CNOT2",
"CNOT3",
"CNOT4",
"CNOT6",
"CNOT6L",
"CNPY3",
"CNPY4",
"CNST",
"CNTF",
"CNTLN",
"CNTN3",
"CNTNAP1",
"CNTNAP2",
"COA6",
"COA7",
"COG2",
"COG3",
"COIL",
"COL12A1",
"COL16A1",
"COL28A1",
"COL2A1",
"COL4A3BP",
"COL5A1",
"COL5A3",
"COL6A3",
"COL6A6",
"COL8A1",
"COL8A2",
"COLEC10",
"COLGALT1",
"COLQ",
"COMMD10",
"COMMD2",
"COMMD3-BMI1",
"COMMD4",
"COMMD7",
"COMTD1",
"COPB1",
"COPG1",
"COPS3",
"COPS5",
"COPS7A",
"COPS7B",
"COPZ2",
"COQ10A",
"COQ5",
"CORO1C",
"CORO7",
"COX10",
"COX17",
"COX18",
"COX4I1",
"COX5A",
"COX7A1",
"COX7A2L",
"CPA5",
"CPA6",
"CPEB3",
"CPEB4",
"CPLX1",
"CPLX2",
"CPN2",
"CPNE2",
"CPNE3",
"CPNE5",
"CPNE7",
"CPNE8",
"CPOX",
"CPSF4",
"CPSF4L",
"CPSF6",
"CPT1A",
"CPT1B",
"CRABP2",
"CRAMP1L",
"CRCP",
"CREB1",
"CREB3L4",
"CREBL2",
"CREBZF",
"CREG1",
"CRELD2",
"CREM",
"CRHR2",
"CRIPT",
"CRLF3",
"CROCC",
"CROCCP2",
"CROCCP3",
"CRTAP",
"CRYBA1",
"CRYM",
"CRYM-AS1",
"CRYZ",
"CS",
"CSE1L-AS1",
"CSGALNACT2",
"CSK",
"CSNK1A1",
"CSNK1D",
"CSNK1G2-AS1",
"CSNK1G3",
"CSNK2A2",
"CSPG4",
"CSRNP2",
"CSRP1",
"CSRP2",
"CSRP2BP",
"CST3",
"CST7",
"CST9",
"CSTF2",
"CSTL1",
"CT83",
"CTBS",
"CTCF",
"CTCFL",
"CTD-2201E9.1",
"CTDSP2",
"CTDSPL2",
"CTGF",
"CTH",
"CTIF",
"CTNNB1",
"CTNNBIP1",
"CTRB2",
"CTRC",
"CTSB",
"CTSH",
"CTSK",
"CTSL",
"CTSO",
"CTSS",
"CTSV",
"CTTNBP2NL",
"CTXN1",
"CUL1",
"CUL2",
"CUL3",
"CUTC",
"CUX1",
"CWC15",
"CWC27",
"CWF19L1",
"CXADR",
"CXCL1",
"CXCL17",
"CXCL2",
"CXCL5",
"CXCL6",
"CXCL8",
"CXCR1",
"CXCR3",
"CXCR5",
"CXorf38",
"CXorf56",
"CXXC5",
"CYB561",
"CYB5R2",
"CYBA",
"CYFIP2",
"CYGB",
"CYHR1",
"CYLD",
"CYP11A1",
"CYP1A1",
"CYP1A2",
"CYP1B1",
"CYP1B1-AS1",
"CYP20A1",
"CYP24A1",
"CYP26B1",
"CYP2A7",
"CYP2D6",
"CYP2G1P",
"CYP3A5",
"CYP3A7",
"CYP3A7-CYP3A51P",
"CYP4B1",
"CYP4F11",
"CYP4Z1",
"CYP8B1",
"CYS1",
"CYSTM1",
"CYTH1",
"CYTH3",
"CYTH4",
"DAAM1",
"DAG1",
"DANCR",
"DAPK1",
"DAPK3",
"DARS",
"DARS-AS1",
"DAW1",
"DAZAP1",
"DAZAP2",
"DBN1",
"DCAF10",
"DCAF12",
"DCAF4",
"DCAF5",
"DCAF6",
"DCAKD",
"DCBLD2",
"DCDC2",
"DCK",
"DCLRE1B",
"DCP1A",
"DCP1B",
"DCP2",
"DCPS",
"DCTD",
"DCTN4",
"DCTN6",
"DCUN1D1",
"DCUN1D2",
"DCUN1D4",
"DDAH1",
"DDAH2",
"DDB2",
"DDHD2",
"DDI2",
"DDIT4",
"DDR2",
"DDRGK1",
"DDTL",
"DDX1",
"DDX11",
"DDX11L16",
"DDX19A",
"DDX20",
"DDX27",
"DDX3X",
"DDX43",
"DDX47",
"DDX59",
"DDX6",
"DDX60",
"DDX60L",
"DEDD2",
"DEF6",
"DEFB1",
"DEFB108B",
"DEGS1",
"DEK",
"DENND2C",
"DENND3",
"DENND4A",
"DENND4B",
"DENND4C",
"DENND5A",
"DEPDC1",
"DEPDC4",
"DEPDC5",
"DEPTOR",
"DERA",
"DERL1",
"DESI1",
"DFFA",
"DFNA5",
"DFNB31",
"DGAT2",
"DGCR14",
"DGCR6L",
"DGKA",
"DGKE",
"DGKI",
"DGUOK-AS1",
"DHCR24",
"DHRS1",
"DHRS11",
"DHRS2",
"DHRS4-AS1",
"DHRS7",
"DHX29",
"DHX32",
"DHX35",
"DHX40",
"DHX9",
"DIAPH2",
"DIAPH3-AS2",
"DIDO1",
"DIEXF",
"DIMT1",
"DIO1",
"DIO2-AS1",
"DIP2C",
"DIRAS1",
"DIRC1",
"DIS3L2",
"DISP1",
"DLAT",
"DLEC1",
"DLEU1",
"DLEU1-AS1",
"DLEU2",
"DLEU7",
"DLG1",
"DLG3",
"DLGAP5",
"DLL4",
"DLX1",
"DLX2",
"DLX3",
"DLX4",
"DLX6-AS1",
"DMBT1",
"DMKN",
"DMP1",
"DMRTA1",
"DMRTA2",
"DMTF1",
"DMXL1",
"DMXL2",
"DNAH1",
"DNAH17",
"DNAH3",
"DNAH5",
"DNAH7",
"DNAJA1",
"DNAJA2",
"DNAJB11",
"DNAJB12",
"DNAJB4",
"DNAJB5",
"DNAJB9",
"DNAJC10",
"DNAJC12",
"DNAJC19",
"DNAJC21",
"DNAJC22",
"DNAJC3",
"DNASE1",
"DNASE1L2",
"DNM2",
"DNMBP-AS1",
"DNMT3A",
"DNPEP",
"DNTTIP2",
"DOCK11",
"DOCK2",
"DOCK5",
"DOCK7",
"DOK2",
"DOK3",
"DOLPP1",
"DOPEY2",
"DPEP2",
"DPF3",
"DPH1",
"DPH3",
"DPH5",
"DPH7",
"DPP8",
"DPY19L1",
"DPY19L1P1",
"DPY19L2P1",
"DPY19L2P3",
"DPY19L4",
"DPYD",
"DRAIC",
"DRAM1",
"DRD4",
"DSC3",
"DSCC1",
"DSCR3",
"DSCR9",
"DSE",
"DSG2",
"DSG3",
"DSP",
"DSPP",
"DTL",
"DTNA",
"DTNB",
"DTWD2",
"DTX2",
"DUSP1",
"DUSP10",
"DUSP12",
"DUSP14",
"DUSP16",
"DUSP18",
"DUSP19",
"DUSP22",
"DUSP23",
"DUSP4",
"DUSP5",
"DUSP6",
"DUT",
"DYM",
"DYNC1LI1",
"DYNC1LI2",
"DYNLRB2",
"DYRK1A",
"DYRK3",
"DYRK4",
"DZIP1L",
"E2F5",
"E2F6",
"E2F8",
"EBAG9",
"EBF3",
"EBLN3",
"EBPL",
"ECHDC1",
"ECHDC3",
"ECHS1",
"ECM2",
"ECSCR",
"ECT2",
"EDAR",
"EDEM1",
"EDEM3",
"EDN1",
"EDNRA",
"EEA1",
"EEF1A1",
"EEF1A2",
"EEF1DP3",
"EFCAB10",
"EFCAB3",
"EFCAB9",
"EFEMP1",
"EFEMP2",
"EFHC1",
"EFHD2",
"EFNA1",
"EFNA3",
"EFNA5",
"EFNB2",
"EFTUD1",
"EGFR",
"EGLN1",
"EGLN2",
"EGLN3",
"EGR1",
"EGR2",
"EGR3",
"EGR4",
"EHD1",
"EHD3",
"EIF1AD",
"EIF1B",
"EIF2A",
"EIF2AK2",
"EIF2B2",
"EIF2B3",
"EIF2B5",
"EIF2S2",
"EIF3A",
"EIF3B",
"EIF3D",
"EIF3E",
"EIF3F",
"EIF3H",
"EIF3K",
"EIF4E",
"EIF4E1B",
"EIF4E3",
"EIF4ENIF1",
"EIF4G3",
"EIF4H",
"EIF5",
"EIF5A2",
"ELAC1",
"ELAC2",
"ELF1",
"ELF4",
"ELK3",
"ELK4",
"ELOF1",
"ELOVL2",
"ELOVL5",
"ELP2",
"EMBP1",
"EMC1",
"EMC10",
"EMC2",
"EMC7",
"EMC8",
"EMC9",
"EMCN",
"EMID1",
"EMILIN1",
"EMILIN2",
"EML5",
"EMP1",
"EMP2",
"EMP3",
"EN1",
"ENAH",
"ENDOD1",
"ENDOV",
"ENG",
"ENKUR",
"ENO1",
"ENO1-AS1",
"ENO4",
"ENOX1",
"ENPEP",
"ENPP4",
"ENSA",
"ENTPD1-AS1",
"ENTPD4",
"ENTPD7",
"EOMES",
"EP400NL",
"EPAS1",
"EPB41",
"EPB41L4A",
"EPB41L5",
"EPC1",
"EPCAM",
"EPG5",
"EPGN",
"EPHA10",
"EPHA2",
"EPHA4",
"EPHA7",
"EPHB4",
"EPHX1",
"EPHX2",
"EPHX4",
"EPN2-AS1",
"EPPK1",
"EPS15L1",
"EPS8L3",
"EPX",
"ERBB2IP",
"ERBB3",
"ERCC6L2",
"ERCC8",
"EREG",
"ERF",
"ERGIC1",
"ERGIC3",
"ERI1",
"ERI3",
"ERICH1",
"ERICH2",
"ERICH5",
"ERMP1",
"ERP27",
"ERRFI1",
"ERVK13-1",
"ESCO1",
"ESD",
"ESPNP",
"ESR1",
"ESRP1",
"ESYT1",
"ESYT2",
"ETAA1",
"ETF1",
"ETHE1",
"ETNK1",
"ETS1",
"ETS2",
"ETV1",
"ETV2",
"ETV4",
"ETV5",
"ETV6",
"EVA1C",
"EVI5",
"EWSAT1",
"EXD2",
"EXO1",
"EXOC2",
"EXOC4",
"EXOG",
"EXOSC1",
"EXOSC2",
"EXOSC4",
"EXOSC9",
"EXPH5",
"EXT2",
"EXTL2",
"EXTL3",
"EXTL3-AS1",
"EYA2",
"EYS",
"EZH2",
"F11R",
"F2",
"F2RL1",
"F3",
"FAAH",
"FABP12",
"FABP2",
"FABP3",
"FABP5",
"FABP5P3",
"FAF1",
"FAF2",
"FAH",
"FAIM",
"FAM102A",
"FAM104B",
"FAM105A",
"FAM106B",
"FAM107B",
"FAM109A",
"FAM109B",
"FAM110B",
"FAM110C",
"FAM111B",
"FAM117A",
"FAM120A",
"FAM127B",
"FAM127C",
"FAM129A",
"FAM129B",
"FAM129C",
"FAM131B",
"FAM131C",
"FAM132B",
"FAM133B",
"FAM134B",
"FAM138B",
"FAM13B",
"FAM150B",
"FAM153C",
"FAM157A",
"FAM159A",
"FAM160A1",
"FAM160B2",
"FAM161A",
"FAM162A",
"FAM166B",
"FAM171B",
"FAM172A",
"FAM172BP",
"FAM174B",
"FAM177A1",
"FAM180A",
"FAM182B",
"FAM183A",
"FAM184A",
"FAM184B",
"FAM186A",
"FAM186B",
"FAM188A",
"FAM189A2",
"FAM193B",
"FAM198B",
"FAM199X",
"FAM19A3",
"FAM200A",
"FAM204A",
"FAM209B",
"FAM20B",
"FAM20C",
"FAM210A",
"FAM212B",
"FAM213A",
"FAM214A",
"FAM214B",
"FAM217A",
"FAM219B",
"FAM220A",
"FAM221B",
"FAM222A",
"FAM222A-AS1",
"FAM222B",
"FAM227A",
"FAM229A",
"FAM231C",
"FAM231D",
"FAM24A",
"FAM25C",
"FAM26D",
"FAM26F",
"FAM27C",
"FAM27E2",
"FAM35A",
"FAM35DP",
"FAM3A",
"FAM46A",
"FAM46B",
"FAM46C",
"FAM47A",
"FAM53A",
"FAM53B",
"FAM53B-AS1",
"FAM57A",
"FAM58A",
"FAM63B",
"FAM65A",
"FAM65C",
"FAM66C",
"FAM69B",
"FAM71D",
"FAM71F2",
"FAM72A",
"FAM72C",
"FAM72D",
"FAM78A",
"FAM83A",
"FAM83A-AS1",
"FAM83B",
"FAM83F",
"FAM84B",
"FAM86B3P",
"FAM86C1",
"FAM86C2P",
"FAM86DP",
"FAM86EP",
"FAM86FP",
"FAM86HP",
"FAM86JP",
"FAM89A",
"FAM8A1",
"FAM90A1",
"FAM91A1",
"FAM96A",
"FAM98A",
"FAN1",
"FANCA",
"FANCC",
"FANCE",
"FANCF",
"FANK1",
"FAP",
"FAR1",
"FAR2",
"FAR2P1",
"FARP2",
"FARS2",
"FARSB",
"FAT1",
"FAT2",
"FBLL1",
"FBP1",
"FBRS",
"FBXL12",
"FBXL13",
"FBXL14",
"FBXL17",
"FBXL20",
"FBXL22",
"FBXL3",
"FBXL4",
"FBXL5",
"FBXO11",
"FBXO15",
"FBXO18",
"FBXO24",
"FBXO25",
"FBXO27",
"FBXO28",
"FBXO3",
"FBXO32",
"FBXO33",
"FBXO34",
"FBXO38",
"FBXO42",
"FBXO43",
"FBXO5",
"FBXO7",
"FBXO8",
"FBXW10",
"FBXW11",
"FBXW2",
"FBXW4",
"FBXW7",
"FCF1",
"FCGR1B",
"FCGR3A",
"FCGRT",
"FCHO2",
"FCHSD2",
"FCN3",
"FCRLB",
"FDX1",
"FECH",
"FEM1B",
"FEM1C",
"FER",
"FER1L5",
"FERMT1",
"FERMT2",
"FEV",
"FEZ1",
"FGD4",
"FGD5",
"FGD5-AS1",
"FGF13",
"FGF22",
"FGFBP3",
"FGFR2",
"FGFRL1",
"FH",
"FHAD1",
"FHDC1",
"FIG4",
"FIGN",
"FILIP1L",
"FIRRE",
"FITM1",
"FJX1",
"FKBP11",
"FKBP14",
"FKBP1A-SDCBP2",
"FKBP1AP1",
"FKBP4",
"FKBP7",
"FKBP9",
"FKBP9P1",
"FKRP",
"FKTN",
"FLAD1",
"FLJ16779",
"FLJ20021",
"FLJ22447",
"FLJ27354",
"FLJ31104",
"FLJ31356",
"FLJ33360",
"FLJ34503",
"FLJ36777",
"FLJ42969",
"FLJ45513",
"FLNB",
"FLOT1",
"FLRT1",
"FLRT3",
"FLVCR2",
"FLYWCH2",
"FMNL1",
"FMO4",
"FMO5",
"FMR1-AS1",
"FN1",
"FN3KRP",
"FNBP1L",
"FNBP4",
"FNDC3A",
"FNDC3B",
"FNDC5",
"FOS",
"FOXA3",
"FOXCUT",
"FOXD1",
"FOXD4",
"FOXE1",
"FOXI1",
"FOXJ1",
"FOXJ2",
"FOXJ3",
"FOXK1",
"FOXK2",
"FOXL1",
"FOXO1",
"FOXO3",
"FOXO4",
"FOXP1",
"FOXP3",
"FOXQ1",
"FOXR1",
"FOXRED2",
"FRAS1",
"FRAT1",
"FRAT2",
"FRG1CP",
"FRG1DP",
"FRG1JP",
"FRK",
"FRMD3",
"FRMD4A",
"FRMD6-AS2",
"FRMD7",
"FRMD8",
"FRMPD2B",
"FRS2",
"FRY-AS1",
"FRYL",
"FRZB",
"FSCN1",
"FSCN2",
"FSD1L",
"FSIP1",
"FSTL1",
"FTCD",
"FTO",
"FTSJ1",
"FUBP1",
"FUCA2",
"FUT4",
"FUT5",
"FUT9",
"FXN",
"FXR1",
"FXYD3",
"FXYD4",
"FXYD7",
"FYCO1",
"FZD1",
"FZD6",
"FZD7",
"FZD8",
"G0S2",
"G2E3",
"G3BP2",
"GAA",
"GAB1",
"GAB3",
"GABARAP",
"GABARAPL3",
"GABPB2",
"GABRE",
"GABRR1",
"GABRR2",
"GAD1",
"GADD45A",
"GADD45G",
"GAL3ST3",
"GALC",
"GALK1",
"GALM",
"GALNT1",
"GALNT10",
"GALNT11",
"GALNT13",
"GALNT14",
"GALNT16",
"GALNT3",
"GALNT7",
"GALR2",
"GAN",
"GAPLINC",
"GAR1",
"GAREM",
"GARS",
"GAS2",
"GAS2L3",
"GAS6-AS1",
"GATA3",
"GATA3-AS1",
"GATA5",
"GATA6",
"GATAD1",
"GATAD2A",
"GATM",
"GATSL3",
"GBE1",
"GBP1P1",
"GBP7",
"GBX2",
"GCA",
"GCC2",
"GCDH",
"GCFC2",
"GCH1",
"GCLC",
"GCLM",
"GCM2",
"GCNT1",
"GCNT2",
"GCOM1",
"GCSH",
"GCSHP3",
"GDA",
"GDF11",
"GDF15",
"GDF9",
"GDPD2",
"GEMIN2",
"GEMIN5",
"GEN1",
"GFI1",
"GFM1",
"GFOD1",
"GFPT1",
"GFPT2",
"GFRA1",
"GFRA3",
"GGA1",
"GGCT",
"GGN",
"GGNBP1",
"GGPS1",
"GGT6",
"GGT8P",
"GHITM",
"GHSR",
"GIF",
"GIGYF2",
"GINS3",
"GIPC1",
"GIPC2",
"GIT2",
"GJA3",
"GJA4",
"GJB3",
"GJB4",
"GJB7",
"GJC3",
"GJD3",
"GK5",
"GLB1",
"GLCE",
"GLDC",
"GLG1",
"GLI1",
"GLIS2",
"GLP1R",
"GLRA1",
"GLRA3",
"GLRX",
"GLRX5",
"GLS2",
"GLT1D1",
"GLT8D2",
"GLTP",
"GLTSCR1",
"GLTSCR2",
"GLYCTK",
"GLYCTK-AS1",
"GM2A",
"GMCL1",
"GMCL1P1",
"GMDS-AS1",
"GMEB2",
"GMFB",
"GMFG",
"GMPS",
"GNA13",
"GNA14-AS1",
"GNAI1",
"GNAQ",
"GNAS",
"GNB1",
"GNB4",
"GNE",
"GNG12-AS1",
"GNPTAB",
"GNRH1",
"GNRH2",
"GNRHR",
"GNS",
"GOLGA2P5",
"GOLGA4",
"GOLGA6A",
"GOLGA6L10",
"GOLGA6L4",
"GOLGA7",
"GOLGA8B",
"GOLGA8M",
"GOLGA8N",
"GOLGA8O",
"GOLGB1",
"GOLIM4",
"GOLM1",
"GOLPH3",
"GOPC",
"GORASP2",
"GOSR2",
"GOT1",
"GOT2",
"GP1BA",
"GPALPP1",
"GPATCH4",
"GPBP1",
"GPC5",
"GPC6",
"GPC6-AS1",
"GPC6-AS2",
"GPCPD1",
"GPD1",
"GPD2",
"GPHN",
"GPI",
"GPLD1",
"GPR101",
"GPR107",
"GPR132",
"GPR143",
"GPR148",
"GPR151",
"GPR155",
"GPR156",
"GPR157",
"GPR171",
"GPR176",
"GPR180",
"GPR182",
"GPR25",
"GPR4",
"GPR45",
"GPR61",
"GPR63",
"GPR65",
"GPR78",
"GPR83",
"GPR85",
"GPR89B",
"GPRC5A",
"GPRC5C",
"GPRC5D",
"GPRIN1",
"GPT2",
"GPX1",
"GPX2",
"GPX5",
"GRAMD1A",
"GRAMD1B",
"GRAMD2",
"GRAMD3",
"GRB7",
"GREB1",
"GREB1L",
"GREM1",
"GRHL2",
"GRHL3",
"GRIFIN",
"GRIK1",
"GRIK2",
"GRIN3A",
"GRINA",
"GRK6",
"GRSF1",
"GRTP1",
"GS1-124K5.11",
"GS1-279B7.1",
"GSC",
"GSG1",
"GSG1L2",
"GSK3B",
"GSN",
"GSPT1",
"GSTM4",
"GSTM5",
"GSTTP2",
"GSTZ1",
"GTF2A1",
"GTF2B",
"GTF2E1",
"GTF2F2",
"GTF2H2C_2",
"GTF2I",
"GTF2IRD1",
"GTF3A",
"GTF3C1",
"GTF3C2",
"GTF3C3",
"GTF3C6",
"GTPBP1",
"GTPBP10",
"GTPBP4",
"GTPBP8",
"GTSF1L",
"GUCA2A",
"GUCY2D",
"GUSBP1",
"GUSBP2",
"GUSBP4",
"GVINP1",
"GXYLT1",
"GXYLT2",
"GYS1",
"GYS2",
"GZMM",
"H1FX-AS1",
"H2AFJ",
"H2AFV",
"H2AFY",
"H3F3A",
"H6PD",
"HAAO",
"HACD1",
"HACE1",
"HADH",
"HAP1",
"HAPLN2",
"HAS1",
"HAS3",
"HAT1",
"HAUS6",
"HAX1",
"HBEGF",
"HBM",
"HBP1",
"HBZ",
"HCAR3",
"HCCS",
"HCFC2",
"HCG11",
"HCG14",
"HCG26",
"HCG27",
"HCG4B",
"HCN3",
"HCRTR1",
"HCST",
"HDAC1",
"HDAC3",
"HDAC4",
"HDAC6",
"HDAC7",
"HDAC9",
"HDDC2",
"HDGF",
"HEATR1",
"HEATR5A",
"HECA",
"HECTD2",
"HECTD2-AS1",
"HECW1",
"HECW2",
"HELB",
"HELLS",
"HELZ",
"HEMGN",
"HEMK1",
"HEPACAM2",
"HEPHL1",
"HERC2P10",
"HERC2P2",
"HERC3",
"HERC4",
"HERPUD1",
"HERPUD2",
"HES1",
"HEXIM2",
"HEY2",
"HGS",
"HHEX",
"HHIP",
"HHLA2",
"HIATL2",
"HIBADH",
"HIC1",
"HIC2",
"HIF1AN",
"HIGD1C",
"HILPDA",
"HINT1",
"HINT3",
"HIPK1-AS1",
"HIST1H1A",
"HIST1H1B",
"HIST1H1D",
"HIST1H1E",
"HIST1H1T",
"HIST1H2AB",
"HIST1H2AC",
"HIST1H2AD",
"HIST1H2AH",
"HIST1H2AL",
"HIST1H2BC",
"HIST1H2BD",
"HIST1H2BF",
"HIST1H2BG",
"HIST1H2BI",
"HIST1H2BJ",
"HIST1H2BM",
"HIST1H2BN",
"HIST1H3A",
"HIST1H3B",
"HIST1H3C",
"HIST1H3E",
"HIST1H3G",
"HIST1H3J",
"HIST1H4B",
"HIST1H4D",
"HIST1H4F",
"HIST1H4H",
"HIST1H4J",
"HIST2H3D",
"HIST3H3",
"HIST4H4",
"HIVEP1",
"HIVEP2",
"HIVEP3",
"HJURP",
"HKR1",
"HLA-A",
"HLA-DMA",
"HLA-F-AS1",
"HM13-AS1",
"HMBOX1",
"HMBS",
"HMGA1",
"HMGA1P7",
"HMGB1",
"HMGB2",
"HMGB3P1",
"HMGCR",
"HMGN1",
"HMGN3",
"HMGN4",
"HN1",
"HNRNPA1L2",
"HNRNPA1P10",
"HNRNPA3",
"HNRNPF",
"HNRNPH1",
"HNRNPL",
"HNRNPR",
"HNRNPU",
"HNRNPU-AS1",
"HOMER1",
"HOMER2",
"HOMER3",
"HOOK2",
"HOOK3",
"HOTAIRM1",
"HOXA-AS2",
"HOXA10-HOXA9",
"HOXB-AS1",
"HOXC-AS3",
"HOXC12",
"HP",
"HP09053",
"HP1BP3",
"HPCA",
"HPD",
"HPGDS",
"HPN-AS1",
"HPR",
"HPRT1",
"HPS3",
"HPS6",
"HRAS",
"HRASLS2",
"HRAT5",
"HRAT92",
"HRCT1",
"HRH4",
"HS1BP3-IT1",
"HS3ST3A1",
"HS3ST3B1",
"HS6ST1",
"HS6ST2",
"HS6ST3",
"HSD11B1",
"HSD17B1",
"HSD17B10",
"HSD17B2",
"HSD17B3",
"HSD17B4",
"HSD17B7",
"HSD17B7P2",
"HSDL1",
"HSF2",
"HSPA12A",
"HSPA13",
"HSPA1B",
"HSPA1L",
"HSPA4",
"HSPA4L",
"HSPA5",
"HSPA8",
"HSPB1",
"HSPB7",
"HSPD1",
"HSPH1",
"HTATSF1",
"HTR6",
"HTR7",
"HTRA1",
"HYAL1",
"HYOU1",
"HYPM",
"IARS",
"IBTK",
"ICA1L",
"ICAM1",
"ICAM4",
"ICE1",
"ICMT",
"ICT1",
"ID1",
"ID2",
"ID3",
"IDH1-AS1",
"IDH2",
"IDS",
"IER2",
"IER3",
"IER3IP1",
"IER5",
"IER5L",
"IFI16",
"IFIH1",
"IFITM4P",
"IFNGR1",
"IFNK",
"IFRD1",
"IFT43",
"IFT52",
"IFT74",
"IFT81",
"IFT88",
"IGBP1P1",
"IGDCC3",
"IGF2BP2",
"IGF2BP3",
"IGFBP4",
"IGFL2",
"IGFL3",
"IGFLR1",
"IGHMBP2",
"IGLON5",
"IGSF1",
"IGSF9",
"IKZF2",
"IKZF3",
"IL10RB",
"IL11RA",
"IL13RA1",
"IL17C",
"IL17D",
"IL17F",
"IL17RD",
"IL17RE",
"IL17REL",
"IL1A",
"IL1B",
"IL1F10",
"IL1R2",
"IL1RAP",
"IL20RB",
"IL23A",
"IL24",
"IL2RG",
"IL32",
"IL3RA",
"IL4R",
"IL7",
"IL7R",
"ILF2",
"ILK",
"IMMP2L",
"IMP3",
"IMPACT",
"IMPAD1",
"IMPDH1",
"IMPG1",
"INA",
"INADL",
"INCENP",
"INF2",
"ING1",
"ING2",
"ING3",
"INHA",
"INHBA",
"INHBB",
"INHBC",
"INIP",
"INO80",
"INO80B-WBP1",
"INO80C",
"INO80D",
"INPP1",
"INPP5D",
"INPPL1",
"INSIG1",
"INSIG2",
"INSM1",
"INTS10",
"INTS4",
"INTS4P2",
"INTS7",
"IPMK",
"IPO11",
"IPO4",
"IPO5",
"IPO8",
"IPO9-AS1",
"IPPK",
"IQCA1",
"IQCB1",
"IQCD",
"IQCG",
"IQCH",
"IQCH-AS1",
"IQCJ-SCHIP1-AS1",
"IQGAP1",
"IQSEC1",
"IQSEC2",
"IQUB",
"IRAIN",
"IRAK1BP1",
"IRAK2",
"IRF1",
"IRF2",
"IRF2BP2",
"IRF2BPL",
"IRF6",
"IRF8",
"IRS2",
"IRX2",
"IRX3",
"IRX4",
"ISL2",
"ISLR",
"ISM1",
"ISOC1",
"ISPD",
"IST1",
"ISY1-RAB43",
"ITFG2",
"ITGA10",
"ITGA11",
"ITGA2",
"ITGA6",
"ITGA7",
"ITGA9",
"ITGAE",
"ITGAV",
"ITGB1",
"ITGB2-AS1",
"ITGB5",
"ITGB6",
"ITGBL1",
"ITIH2",
"ITIH6",
"ITPR2",
"ITPR3",
"ITPRIP",
"ITPRIPL2",
"IZUMO2",
"IZUMO4",
"JADE1",
"JADE2",
"JADE3",
"JAG1",
"JAM3",
"JARID2-AS1",
"JDP2",
"JMJD1C",
"JMY",
"JOSD1",
"JPH1",
"JPX",
"JRKL",
"JUN",
"JUP",
"KALRN",
"KANK1",
"KANK3",
"KANSL1L",
"KANTR",
"KAT2B",
"KAT6A",
"KAT7",
"KAT8",
"KATNA1",
"KATNAL1",
"KATNAL2",
"KAZALD1",
"KBTBD11",
"KBTBD12",
"KBTBD2",
"KBTBD8",
"KCCAT211",
"KCCAT333",
"KCMF1",
"KCNAB1",
"KCNC4",
"KCND3",
"KCND3-AS1",
"KCNG1",
"KCNG3",
"KCNIP4",
"KCNJ11",
"KCNJ15",
"KCNJ3",
"KCNK18",
"KCNMB2",
"KCNN4",
"KCNQ2",
"KCNQ5-AS1",
"KCNRG",
"KCNS2",
"KCNV2",
"KCP",
"KCTD12",
"KCTD13",
"KCTD15",
"KCTD18",
"KCTD3",
"KCTD5",
"KCTD7",
"KDM2A",
"KDM3A",
"KDM3B",
"KDM4A",
"KDM4C",
"KDM6A",
"KDM6B",
"KDM7A",
"KDM8",
"KDSR",
"KHDRBS1",
"KIAA0020",
"KIAA0040",
"KIAA0101",
"KIAA0141",
"KIAA0226",
"KIAA0232",
"KIAA0319",
"KIAA0355",
"KIAA0513",
"KIAA0586",
"KIAA0753",
"KIAA0907",
"KIAA0922",
"KIAA1024",
"KIAA1024L",
"KIAA1161",
"KIAA1191",
"KIAA1217",
"KIAA1257",
"KIAA1549",
"KIAA1549L",
"KIAA1586",
"KIAA1671",
"KIAA1715",
"KIAA1841",
"KIAA1958",
"KIAA2012",
"KIAA2013",
"KIAA2018",
"KIAA2022",
"KIDINS220",
"KIF12",
"KIF13A",
"KIF13B",
"KIF16B",
"KIF17",
"KIF18A",
"KIF18B",
"KIF1B",
"KIF21B",
"KIF22",
"KIF26A",
"KIF26B",
"KIF2A",
"KIF2C",
"KIF3A",
"KIF5B",
"KIFC2",
"KIFC3",
"KIRREL3",
"KITLG",
"KLB",
"KLF10",
"KLF12",
"KLF13",
"KLF16",
"KLF3-AS1",
"KLF4",
"KLF5",
"KLF6",
"KLF8",
"KLHDC10",
"KLHDC2",
"KLHDC7B",
"KLHDC8B",
"KLHDC9",
"KLHL12",
"KLHL2",
"KLHL21",
"KLHL26",
"KLHL3",
"KLHL31",
"KLHL32",
"KLHL33",
"KLHL36",
"KLHL42",
"KLHL5",
"KLHL9",
"KLK14",
"KLRB1",
"KMT2A",
"KMT2C",
"KPNA2",
"KPNA3",
"KPNA4",
"KPNB1",
"KRAS",
"KRBA1",
"KRBOX4",
"KRCC1",
"KRT14",
"KRT15",
"KRT18P55",
"KRT19",
"KRT222",
"KRT5",
"KRT7",
"KRT75",
"KRT8",
"KRT80",
"KRT81",
"KRT9",
"KRTAP5-9",
"KSR1",
"KY",
"KYNU",
"LACE1",
"LAMA2",
"LAMA3",
"LAMA5",
"LAMB1",
"LAMB3",
"LAMB4",
"LAMC1",
"LAMC2",
"LAMP2",
"LANCL2",
"LAP3",
"LAPTM4A",
"LAPTM4B",
"LARGE",
"LARGE-AS1",
"LARP1",
"LARP1B",
"LARP7",
"LARS2",
"LATS2",
"LBP",
"LBR",
"LCA5",
"LCA5L",
"LCMT2",
"LCN2",
"LCORL",
"LDAH",
"LDB1",
"LDB2",
"LDB3",
"LDHA",
"LDHB",
"LDHC",
"LDLR",
"LDLRAD3",
"LDOC1",
"LDOC1L",
"LEKR1",
"LEMD1",
"LEO1",
"LETM2",
"LFNG",
"LGALS3",
"LGALS9",
"LGI3",
"LHFP",
"LHFPL4",
"LHX1",
"LHX4",
"LIF",
"LIFR-AS1",
"LIG3",
"LIN28A",
"LIN52",
"LIN54",
"LIN7A",
"LIN7C",
"LIN9",
"LINC00112",
"LINC00152",
"LINC00162",
"LINC00163",
"LINC00174",
"LINC00189",
"LINC00202-1",
"LINC00238",
"LINC00243",
"LINC00244",
"LINC00265",
"LINC00266-1",
"LINC00282",
"LINC00309",
"LINC00310",
"LINC00311",
"LINC00312",
"LINC00313",
"LINC00319",
"LINC00333",
"LINC00346",
"LINC00365",
"LINC00382",
"LINC00417",
"LINC00421",
"LINC00423",
"LINC00431",
"LINC00442",
"LINC00456",
"LINC00460",
"LINC00461",
"LINC00470",
"LINC00486",
"LINC00493",
"LINC00518",
"LINC00536",
"LINC00539",
"LINC00565",
"LINC00571",
"LINC00598",
"LINC00607",
"LINC00615",
"LINC00623",
"LINC00628",
"LINC00629",
"LINC00630",
"LINC00640",
"LINC00656",
"LINC00657",
"LINC00662",
"LINC00674",
"LINC00685",
"LINC00691",
"LINC00696",
"LINC00700",
"LINC00702",
"LINC00704",
"LINC00706",
"LINC00707",
"LINC00857",
"LINC00869",
"LINC00880",
"LINC00884",
"LINC00885",
"LINC00887",
"LINC00894",
"LINC00896",
"LINC00899",
"LINC00907",
"LINC00908",
"LINC00909",
"LINC00910",
"LINC00920",
"LINC00930",
"LINC00936",
"LINC00938",
"LINC00941",
"LINC00950",
"LINC00957",
"LINC00958",
"LINC00959",
"LINC00960",
"LINC00963",
"LINC00970",
"LINC00999",
"LINC01000",
"LINC01003",
"LINC01004",
"LINC01012",
"LINC01023",
"LINC01031",
"LINC01032",
"LINC01033",
"LINC01038",
"LINC01054",
"LINC01057",
"LINC01058",
"LINC01063",
"LINC01072",
"LINC01080",
"LINC01090",
"LINC01094",
"LINC01107",
"LINC01108",
"LINC01118",
"LINC01121",
"LINC01123",
"LINC01128",
"LINC01132",
"LINC01133",
"LINC01137",
"LINC01138",
"LINC01139",
"LINC01140",
"LINC01141",
"LINC01143",
"LINC01168",
"LINC01179",
"LINC01184",
"LINC01213",
"LINC01214",
"LINC01227",
"LINC01239",
"LINC01250",
"LINC01252",
"LINC01260",
"LINC01269",
"LINC01270",
"LINC01271",
"LINC01272",
"LINC01273",
"LINC01276",
"LINC01279",
"LINC01298",
"LINC01315",
"LINC01335",
"LINC01340",
"LINC01341",
"LINC01348",
"LINC01352",
"LINC01353",
"LINC01356",
"LINC01359",
"LINC01364",
"LINC01386",
"LINC01397",
"LINC01411",
"LINC01423",
"LINC01426",
"LINC01431",
"LINC01433",
"LINC01450",
"LINC01468",
"LINC01473",
"LINC01476",
"LINC01479",
"LINC01485",
"LINC01488",
"LINC01494",
"LINC01504",
"LINC01511",
"LINC01523",
"LINC01530",
"LINC01534",
"LINC01549",
"LINC01554",
"LINC01561",
"LINC01563",
"LINC01564",
"LINC01565",
"LINC01572",
"LINC01573",
"LINC01578",
"LINC01583",
"LINC01588",
"LINC01590",
"LINC01605",
"LINGO4",
"LIPE",
"LIPG",
"LIPH",
"LIPI",
"LIPT2",
"LITAF",
"LIX1L",
"LMAN1",
"LMBR1",
"LMBRD1",
"LMF1",
"LMF1-AS1",
"LMNB1",
"LMO3",
"LMOD1",
"LMTK3",
"LNX2",
"LOC100049716",
"LOC100128233",
"LOC100128531",
"LOC100128770",
"LOC100129027",
"LOC100129148",
"LOC100129461",
"LOC100129697",
"LOC100129931",
"LOC100129940",
"LOC100129973",
"LOC100130075",
"LOC100130264",
"LOC100130417",
"LOC100130987",
"LOC100130992",
"LOC100131107",
"LOC100131289",
"LOC100131496",
"LOC100131626",
"LOC100132111",
"LOC100132781",
"LOC100133091",
"LOC100133331",
"LOC100133920",
"LOC100133985",
"LOC100144595",
"LOC100287036",
"LOC100287072",
"LOC100287632",
"LOC100287728",
"LOC100288181",
"LOC100288254",
"LOC100288748",
"LOC100303749",
"LOC100419583",
"LOC100422556",
"LOC100499484-C9ORF174",
"LOC100505478",
"LOC100505530",
"LOC100505921",
"LOC100505984",
"LOC100506125",
"LOC100506127",
"LOC100506136",
"LOC100506178",
"LOC100506314",
"LOC100506393",
"LOC100506639",
"LOC100506746",
"LOC100506801",
"LOC100506844",
"LOC100506985",
"LOC100506990",
"LOC100507065",
"LOC100507250",
"LOC100507373",
"LOC100507487",
"LOC100507557",
"LOC100507642",
"LOC100996291",
"LOC100996579",
"LOC100996583",
"LOC100996693",
"LOC101054525",
"LOC101060091",
"LOC101060542",
"LOC101241902",
"LOC101243545",
"LOC101805491",
"LOC101926905",
"LOC101926933",
"LOC101926941",
"LOC101927018",
"LOC101927021",
"LOC101927027",
"LOC101927043",
"LOC101927100",
"LOC101927120",
"LOC101927131",
"LOC101927143",
"LOC101927211",
"LOC101927237",
"LOC101927257",
"LOC101927286",
"LOC101927296",
"LOC101927378",
"LOC101927412",
"LOC101927415",
"LOC101927418",
"LOC101927438",
"LOC101927450",
"LOC101927472",
"LOC101927478",
"LOC101927481",
"LOC101927526",
"LOC101927571",
"LOC101927572",
"LOC101927588",
"LOC101927620",
"LOC101927657",
"LOC101927666",
"LOC101927692",
"LOC101927701",
"LOC101927762",
"LOC101927770",
"LOC101927787",
"LOC101927817",
"LOC101927851",
"LOC101927865",
"LOC101927884",
"LOC101927905",
"LOC101927934",
"LOC101927948",
"LOC101927950",
"LOC101927967",
"LOC101928043",
"LOC101928053",
"LOC101928075",
"LOC101928118",
"LOC101928131",
"LOC101928163",
"LOC101928222",
"LOC101928227",
"LOC101928253",
"LOC101928272",
"LOC101928283",
"LOC101928323",
"LOC101928335",
"LOC101928370",
"LOC101928461",
"LOC101928491",
"LOC101928514",
"LOC101928569",
"LOC101928605",
"LOC101928626",
"LOC101928682",
"LOC101928708",
"LOC101928710",
"LOC101928731",
"LOC101928737",
"LOC101928751",
"LOC101928794",
"LOC101928812",
"LOC101928844",
"LOC101928944",
"LOC101928973",
"LOC101929023",
"LOC101929034",
"LOC101929057",
"LOC101929080",
"LOC101929125",
"LOC101929162",
"LOC101929259",
"LOC101929295",
"LOC101929378",
"LOC101929380",
"LOC101929395",
"LOC101929452",
"LOC101929464",
"LOC101929470",
"LOC101929504",
"LOC101929512",
"LOC101929524",
"LOC101929567",
"LOC101929574",
"LOC101929577",
"LOC101929584",
"LOC101929613",
"LOC101929622",
"LOC101929694",
"LOC101929705",
"LOC101929715",
"LOC101929718",
"LOC101929719",
"LOC101929767",
"LOC101929771",
"LOC101930010",
"LOC101930452",
"LOC102031319",
"LOC102467147",
"LOC102467223",
"LOC102546229",
"LOC102546294",
"LOC102723344",
"LOC102723517",
"LOC102723544",
"LOC102723703",
"LOC102723769",
"LOC102723809",
"LOC102723828",
"LOC102723854",
"LOC102724050",
"LOC102724153",
"LOC102724201",
"LOC102724301",
"LOC102724421",
"LOC102724434",
"LOC102724467",
"LOC102724511",
"LOC102724539",
"LOC102724589",
"LOC102724919",
"LOC102724927",
"LOC102800447",
"LOC103611081",
"LOC105375734",
"LOC105376360",
"LOC105377348",
"LOC105447648",
"LOC105616981",
"LOC115110",
"LOC143666",
"LOC145474",
"LOC145783",
"LOC146880",
"LOC148709",
"LOC149950",
"LOC152225",
"LOC221122",
"LOC255187",
"LOC283140",
"LOC283710",
"LOC284009",
"LOC284080",
"LOC284788",
"LOC285074",
"LOC285593",
"LOC285627",
"LOC285889",
"LOC338694",
"LOC338963",
"LOC339539",
"LOC339807",
"LOC340017",
"LOC344967",
"LOC374443",
"LOC388282",
"LOC388406",
"LOC389247",
"LOC389332",
"LOC389602",
"LOC392364",
"LOC400043",
"LOC400553",
"LOC400684",
"LOC400927-CSNK1E",
"LOC401177",
"LOC439994",
"LOC440028",
"LOC440390",
"LOC440434",
"LOC440461",
"LOC440910",
"LOC441204",
"LOC441242",
"LOC441454",
"LOC553103",
"LOC554206",
"LOC613266",
"LOC63930",
"LOC642846",
"LOC643387",
"LOC645513",
"LOC646029",
"LOC646736",
"LOC646903",
"LOC648987",
"LOC653513",
"LOC653602",
"LOC653653",
"LOC653786",
"LOC728323",
"LOC729218",
"LOC729987",
"LOC730668",
"LOC79160",
"LOC91450",
"LOC93622",
"LONP2",
"LONRF3",
"LOX",
"LOXL1-AS1",
"LOXL2",
"LOXL3",
"LOXL4",
"LPAR3",
"LPCAT3",
"LPO",
"LPPR2",
"LRAT",
"LRBA",
"LRCH3",
"LRFN1",
"LRGUK",
"LRIF1",
"LRIG2",
"LRIG3",
"LRP10",
"LRP11",
"LRP12",
"LRP2BP",
"LRPPRC",
"LRRC1",
"LRRC16A",
"LRRC16B",
"LRRC27",
"LRRC3",
"LRRC37A",
"LRRC37A11P",
"LRRC37A2",
"LRRC37A6P",
"LRRC37A8P",
"LRRC37B",
"LRRC39",
"LRRC3C",
"LRRC40",
"LRRC42",
"LRRC56",
"LRRC58",
"LRRC63",
"LRRC75A",
"LRRC8B",
"LRRC8C",
"LRRC8D",
"LRRC8E",
"LRRC9",
"LRRFIP1",
"LRRFIP2",
"LRRK1",
"LRRK2",
"LRRN1",
"LRRN2",
"LRRN3",
"LRRTM3",
"LRTOMT",
"LSAMP",
"LSG1",
"LSM10",
"LSM14A",
"LSM5",
"LSM6",
"LSM8",
"LSMEM1",
"LTA",
"LTA4H",
"LTB",
"LTBP2",
"LTN1",
"LTV1",
"LUC7L3",
"LURAP1",
"LURAP1L",
"LURAP1L-AS1",
"LUZP1",
"LUZP6",
"LY6G5C",
"LYG1",
"LYG2",
"LYN",
"LYPD6",
"LYPD6B",
"LYPLA2",
"LYRM7",
"LYSMD3",
"LZTS3",
"MACC1",
"MACROD2",
"MACROD2-AS1",
"MAD1L1",
"MAD2L1",
"MAEA",
"MAFA-AS1",
"MAFB",
"MAGEF1",
"MAGI1",
"MAGI3",
"MAGIX",
"MAK",
"MAL2",
"MALAT1",
"MAML1",
"MAN1A1",
"MAN1A2",
"MAN2A1",
"MANSC1",
"MANSC4",
"MAP1A",
"MAP1LC3A",
"MAP2K1",
"MAP2K2",
"MAP2K3",
"MAP2K5",
"MAP2K6",
"MAP3K1",
"MAP3K13",
"MAP3K19",
"MAP3K3",
"MAP3K4",
"MAP3K5",
"MAP3K7",
"MAP3K8",
"MAP3K9",
"MAP4K4",
"MAP6",
"MAP6D1",
"MAP7",
"MAP7D1",
"MAPK1",
"MAPK12",
"MAPK13",
"MAPK15",
"MAPK1IP1L",
"MAPK4",
"MAPK6",
"MAPK8",
"MAPK9",
"MAPKAP1",
"MAPKAPK2",
"MAPKAPK3",
"MAPKBP1",
"MAPRE3",
"MAPT",
"MARCH10",
"MARCH3",
"MARCH6",
"MARCH9",
"MARCO",
"MARK2",
"MARK2P9",
"MARK3",
"MARS2",
"MARVELD1",
"MAT2A",
"MAT2B",
"MATN2",
"MATR3",
"MAU2",
"MAVS",
"MB",
"MB21D1",
"MB21D2",
"MBLAC1",
"MBNL1",
"MBNL2",
"MBNL3",
"MBOAT1",
"MBOAT2",
"MBTPS2",
"MCCC1",
"MCCC2",
"MCF2L-AS1",
"MCF2L2",
"MCFD2",
"MCM10",
"MCM3",
"MCM3AP",
"MCPH1-AS1",
"MCTP1",
"MCTP2",
"MCUR1",
"MDC1",
"MDFI",
"MDH1",
"MDH2",
"MDM1",
"MDM4",
"MDN1",
"MDS2",
"ME1",
"ME2",
"ME3",
"MEA1",
"MED10",
"MED12L",
"MED13L",
"MED15",
"MED18",
"MED24",
"MED30",
"MED31",
"MED9",
"MEF2A",
"MEF2D",
"MEGF6",
"MEGF8",
"MEGF9",
"MEIKIN",
"MEIOB",
"MEIS1-AS2",
"MEIS2",
"MELK",
"MEMO1",
"MEP1B",
"MET",
"METAP1",
"METAP1D",
"METAP2",
"METRNL",
"METTL13",
"METTL17",
"METTL18",
"METTL20",
"METTL22",
"METTL24",
"METTL25",
"METTL2A",
"METTL2B",
"METTL4",
"METTL9",
"MEX3C",
"MFAP3",
"MFHAS1",
"MFI2",
"MFN1",
"MFN2",
"MFSD1",
"MFSD12",
"MFSD2B",
"MFSD5",
"MGA",
"MGAT1",
"MGAT4EP",
"MGAT5",
"MGC27345",
"MGC45922",
"MGME1",
"MGP",
"MGRN1",
"MGST1",
"MGST3",
"MIA3",
"MIATNB",
"MICA",
"MICAL2",
"MICALCL",
"MICALL2",
"MICB",
"MICU1",
"MICU2",
"MICU3",
"MID1",
"MID1IP1",
"MID1IP1-AS1",
"MID2",
"MIDN",
"MIER1",
"MILR1",
"MINA",
"MINK1",
"MINOS1",
"MINPP1",
"MIOS",
"MIPEP",
"MIPOL1",
"MIR100HG",
"MIR1181",
"MIR1199",
"MIR1204",
"MIR1208",
"MIR124-3",
"MIR1244-3",
"MIR1257",
"MIR1268A",
"MIR1273C",
"MIR1275",
"MIR1289-1",
"MIR129-1",
"MIR1299",
"MIR1303",
"MIR1305",
"MIR130A",
"MIR132",
"MIR135A2",
"MIR137HG",
"MIR138-1",
"MIR152",
"MIR1538",
"MIR155HG",
"MIR181A2HG",
"MIR181C",
"MIR182",
"MIR1827",
"MIR193A",
"MIR193B",
"MIR200B",
"MIR205",
"MIR2052HG",
"MIR205HG",
"MIR217HG",
"MIR2682",
"MIR296",
"MIR301B",
"MIR3149",
"MIR3159",
"MIR3168",
"MIR3195",
"MIR325HG",
"MIR3607",
"MIR3610",
"MIR3648-2",
"MIR3649",
"MIR3671",
"MIR3674",
"MIR3680-1",
"MIR3688-2",
"MIR375",
"MIR378I",
"MIR3907",
"MIR3913-2",
"MIR3925",
"MIR3927",
"MIR3960",
"MIR4252",
"MIR4259",
"MIR4268",
"MIR4272",
"MIR4280",
"MIR4309",
"MIR4313",
"MIR4424",
"MIR4425",
"MIR4431",
"MIR4435-1",
"MIR4435-2HG",
"MIR4443",
"MIR4449",
"MIR4452",
"MIR4466",
"MIR4467",
"MIR4470",
"MIR4472-2",
"MIR4477B",
"MIR4481",
"MIR4487",
"MIR4513",
"MIR4514",
"MIR4521",
"MIR4523",
"MIR4638",
"MIR4641",
"MIR4645",
"MIR4657",
"MIR4666A",
"MIR4678",
"MIR4682",
"MIR4710",
"MIR4734",
"MIR4737",
"MIR4740",
"MIR4756",
"MIR4766",
"MIR4767",
"MIR4771-2",
"MIR4776-2",
"MIR4778",
"MIR4786",
"MIR4788",
"MIR505",
"MIR5087",
"MIR5089",
"MIR5091",
"MIR5093",
"MIR548AQ",
"MIR548AZ",
"MIR548I1",
"MIR548I2",
"MIR550B1",
"MIR5580",
"MIR5684",
"MIR5693",
"MIR5694",
"MIR5695",
"MIR5702",
"MIR5703",
"MIR5739",
"MIR600HG",
"MIR607",
"MIR6076",
"MIR6088",
"MIR612",
"MIR633",
"MIR641",
"MIR6509",
"MIR651",
"MIR6720",
"MIR6723",
"MIR6734",
"MIR6756",
"MIR6759",
"MIR6766",
"MIR6787",
"MIR6791",
"MIR6793",
"MIR6812",
"MIR6850",
"MIR7156",
"MIR762HG",
"MIR7641-2",
"MIR7845",
"MIR8056",
"MIR8068",
"MIR8072",
"MIR8079",
"MIR8086",
"MIRLET7A3",
"MIRLET7DHG",
"MIRLET7I",
"MIS18A",
"MIXL1",
"MKI67",
"MKL1",
"MKL2",
"MKLN1",
"MKNK2",
"MKRN1",
"MKRN9P",
"MLANA",
"MLF2",
"MLK7-AS1",
"MLKL",
"MLLT1",
"MLLT10",
"MLLT11",
"MLPH",
"MLST8",
"MLX",
"MLXIP",
"MMADHC",
"MMP11",
"MMP14",
"MMP16",
"MMP19",
"MMP21",
"MMP9",
"MNAT1",
"MND1",
"MNS1",
"MNX1",
"MOB1B",
"MOB3C",
"MOBP",
"MOCOS",
"MOCS3",
"MOG",
"MON1A",
"MON2",
"MORC4",
"MORN3",
"MPC1",
"MPDZ",
"MPG",
"MPHOSPH6",
"MPL",
"MPP1",
"MPP7",
"MPRIP",
"MPST",
"MPZ",
"MPZL1",
"MPZL2",
"MR1",
"MRC2",
"MREG",
"MRFAP1",
"MRGBP",
"MRGPRX2",
"MRPL12",
"MRPL15",
"MRPL17",
"MRPL22",
"MRPL3",
"MRPL32",
"MRPL33",
"MRPL34",
"MRPL36",
"MRPL39",
"MRPL4",
"MRPL41",
"MRPL44",
"MRPL48",
"MRPL55",
"MRPL57",
"MRPS11",
"MRPS15",
"MRPS17",
"MRPS2",
"MRPS21",
"MRPS23",
"MRPS26",
"MRPS30",
"MRPS31",
"MRPS31P5",
"MRPS35",
"MRPS6",
"MRPS9",
"MRRF",
"MRVI1",
"MSANTD1",
"MSANTD4",
"MSC",
"MSC-AS1",
"MSH6",
"MSI2",
"MSL1",
"MSL2",
"MSL3",
"MSMO1",
"MSN",
"MSRA",
"MSRB2",
"MSS51",
"MST1P2",
"MSTO1",
"MSX2",
"MT1L",
"MT2A",
"MTA2",
"MTCH1",
"MTCL1",
"MTERF1",
"MTF2",
"MTHFD1",
"MTHFD1L",
"MTHFD2L",
"MTHFSD",
"MTIF3",
"MTMR6",
"MTMR9",
"MTMR9LP",
"MTO1",
"MTOR",
"MTR",
"MTSS1",
"MUC20",
"MUC4",
"MUC5AC",
"MUC5B",
"MUC6",
"MUL1",
"MUTYH",
"MVK",
"MXD1",
"MXD4",
"MXRA7",
"MXRA8",
"MYADM",
"MYBL1",
"MYBL2",
"MYBPC1",
"MYBPC2",
"MYBPHL",
"MYC",
"MYD88",
"MYEOV",
"MYEOV2",
"MYH10",
"MYH14",
"MYH16",
"MYH3",
"MYH9",
"MYL12B",
"MYL7",
"MYLK",
"MYLK3",
"MYNN",
"MYO16",
"MYO19",
"MYO1B",
"MYO1C",
"MYO1D",
"MYO1E",
"MYO1G",
"MYO1H",
"MYO6",
"MYOF",
"MYOM1",
"MYOZ1",
"MYPN",
"MYPOP",
"MZF1",
"MZF1-AS1",
"MZT1",
"N4BP2",
"N4BP3",
"NAA15",
"NAA16",
"NAA30",
"NAA38",
"NAA60",
"NAALAD2",
"NAB1",
"NABP1",
"NABP2",
"NACA",
"NACA2",
"NACAP1",
"NACC2",
"NAGK",
"NAGS",
"NAIP",
"NAMPT",
"NANP",
"NANS",
"NAPSA",
"NAPSB",
"NARF",
"NARFL",
"NARS2",
"NAT10",
"NAT14",
"NAT8B",
"NATD1",
"NAV1",
"NBAS",
"NBPF1",
"NBPF12",
"NBPF14",
"NBPF15",
"NBPF18P",
"NBPF20",
"NBPF4",
"NBPF6",
"NBPF8",
"NBPF9",
"NCAPG2",
"NCAPH",
"NCF2",
"NCF4",
"NCK2",
"NCKAP1",
"NCKAP5",
"NCL",
"NCLN",
"NCOA1",
"NCR3LG1",
"NCS1",
"NDEL1",
"NDFIP1",
"NDRG1",
"NDRG3",
"NDUFA1",
"NDUFA11",
"NDUFA12",
"NDUFA4",
"NDUFA4L2",
"NDUFAF1",
"NDUFAF4",
"NDUFAF5",
"NDUFAF6",
"NDUFB2",
"NDUFB4",
"NDUFB8",
"NDUFS6",
"NDUFS7",
"NDUFV1",
"NDUFV3",
"NEAT1",
"NEB",
"NECAB1",
"NECAP1",
"NECAP2",
"NEDD1",
"NEDD4",
"NEDD9",
"NEFH",
"NEFM",
"NEGR1",
"NEIL3",
"NEK1",
"NEK7",
"NELFCD",
"NEMP2",
"NENF",
"NEO1",
"NES",
"NET1",
"NETO2",
"NEU3",
"NEUROD2",
"NF1",
"NF2",
"NFATC1",
"NFATC2",
"NFE2L1",
"NFE2L2",
"NFIA",
"NFIB",
"NFIC",
"NFIL3",
"NFKB1",
"NFKBIA",
"NFKBID",
"NFKBIZ",
"NFU1",
"NFYB",
"NFYC",
"NGRN",
"NHLH1",
"NHLRC1",
"NHLRC2",
"NHS",
"NHSL1",
"NID1",
"NID2",
"NIN",
"NINL",
"NIPA2",
"NIPAL1",
"NIPAL2",
"NIPAL4",
"NIPBL",
"NIPBL-AS1",
"NIPSNAP3A",
"NIT2",
"NKAIN4",
"NKAP",
"NKAPP1",
"NKD2",
"NKPD1",
"NKX1-2",
"NKX3-1",
"NLGN1",
"NLGN1-AS1",
"NLGN3",
"NLK",
"NLN",
"NLRC4",
"NLRP6",
"NLRP9",
"NME1-NME2",
"NME6",
"NMI",
"NMNAT1",
"NMUR1",
"NNMT",
"NNT",
"NOB1",
"NODAL",
"NOL11",
"NOL6",
"NOLC1",
"NOM1",
"NOP16",
"NOP9",
"NOS1AP",
"NOTCH2",
"NOTCH2NL",
"NOTCH3",
"NOTUM",
"NOVA2",
"NOX5",
"NOXO1",
"NPAS1",
"NPAS2",
"NPBWR1",
"NPC1",
"NPC1L1",
"NPC2",
"NPEPPS",
"NPHP3-ACAD11",
"NPIPB15",
"NPIPB9",
"NPLOC4",
"NPNT",
"NPRL3",
"NPY1R",
"NPY4R",
"NR0B2",
"NR1D1",
"NR1D2",
"NR2C1",
"NR2E3",
"NR2F1",
"NR2F2-AS1",
"NR3C2",
"NR4A2",
"NR6A1",
"NRADDP",
"NRARP",
"NRBF2",
"NRBP1",
"NRDE2",
"NRF1",
"NRG4",
"NRIP2",
"NRL",
"NRP1",
"NRSN1",
"NRSN2",
"NRSN2-AS1",
"NSF",
"NSFP1",
"NSMCE4A",
"NSUN6",
"NT5C1B",
"NT5C2",
"NT5C3A",
"NT5DC1",
"NT5E",
"NTF4",
"NTN3",
"NTPCR",
"NUAK1",
"NUAK2",
"NUCB1",
"NUCB2",
"NUCKS1",
"NUDCD1",
"NUDCD3",
"NUDT15",
"NUDT19",
"NUDT2",
"NUDT3",
"NUDT9",
"NUDT9P1",
"NUFIP1",
"NUFIP2",
"NUMB",
"NUMBL",
"NUP153",
"NUP160",
"NUP210",
"NUP210L",
"NUP214",
"NUP43",
"NUP50",
"NUP93",
"NUPL1",
"NUS1",
"NUTM2F",
"NUTM2G",
"NVL",
"NXN",
"NXNL2",
"NXPH1",
"NXPH3",
"NXPH4",
"NYAP1",
"NYAP2",
"NYNRIN",
"OAF",
"OAZ2",
"OBFC1",
"OCIAD2",
"OCLN",
"OCRL",
"ODC1",
"ODF2L",
"ODF3B",
"ODF3L2",
"OGDH",
"OGFOD3",
"OGFR-AS1",
"OGFRL1",
"OGG1",
"OGN",
"OLA1",
"OLFML1",
"OLFML2A",
"OMD",
"ONECUT1",
"ONECUT3",
"OOEP",
"OPA1",
"OPTC",
"OPTN",
"OR10A2",
"OR10A4",
"OR10AD1",
"OR10K2",
"OR10T2",
"OR10V2P",
"OR13D1",
"OR13G1",
"OR13H1",
"OR1K1",
"OR1L6",
"OR2AG1",
"OR2B2",
"OR2B6",
"OR2D3",
"OR2H2",
"OR4F16",
"OR4F21",
"OR5C1",
"OR5K2",
"OR5M11",
"OR6A2",
"OR6S1",
"OR7E14P",
"OR8B12",
"OR8B2",
"OR8B3",
"OR8B4",
"OR8B8",
"OR8D1",
"OR8D2",
"OR8G1",
"OR8G2",
"OR8G5",
"ORAI1",
"ORC2",
"OSBP",
"OSBP2",
"OSBPL11",
"OSBPL3",
"OSBPL8",
"OSBPL9",
"OSCP1",
"OSER1-AS1",
"OSGEPL1",
"OSGIN1",
"OSR1",
"OSR2",
"OSTF1",
"OTOA",
"OTOS",
"OTUB2",
"OTUD1",
"OTUD4",
"OTUD6B-AS1",
"OTUD7B",
"OTX1",
"OVCH2",
"OVOL1",
"OVOL1-AS1",
"OVOL3",
"OXNAD1",
"OXTR",
"P2RX5",
"P2RY1",
"P2RY12",
"P2RY14",
"P2RY2",
"P2RY4",
"P2RY6",
"P3H3",
"P4HA2",
"P4HB",
"PA2G4",
"PA2G4P4",
"PABPC1",
"PABPC4L",
"PACS2",
"PACSIN2",
"PACSIN3",
"PAFAH1B1",
"PAFAH1B2",
"PAFAH2",
"PAIP1",
"PALD1",
"PALLD",
"PALM2",
"PALM2-AKAP2",
"PALM3",
"PAM",
"PANK1",
"PANK2",
"PANK4",
"PANX1",
"PANX2",
"PAPD5",
"PAPD7",
"PAPOLG",
"PAPPA",
"PAPSS1",
"PAQR3",
"PAQR5",
"PAQR7",
"PAQR8",
"PARD3-AS1",
"PARD3B",
"PARD6B",
"PARD6G",
"PARK7",
"PARP1",
"PARP11",
"PARP14",
"PARP16",
"PARP4",
"PARP6",
"PARP8",
"PARS2",
"PARVA",
"PATE1",
"PATE2",
"PATE3",
"PATE4",
"PATL1",
"PATL2",
"PATZ1",
"PAX8",
"PAX9",
"PBLD",
"PBX1",
"PBX4",
"PBXIP1",
"PCAT1",
"PCAT2",
"PCAT29",
"PCCA-AS1",
"PCDH1",
"PCDH12",
"PCDH20",
"PCDH7",
"PCDH8",
"PCDHA1",
"PCDHB15",
"PCDHB17P",
"PCDHB18P",
"PCDHB19P",
"PCDHB2",
"PCDHB4",
"PCDHB5",
"PCED1B",
"PCED1B-AS1",
"PCF11",
"PCGF2",
"PCIF1",
"PCM1",
"PCMT1",
"PCMTD1",
"PCMTD2",
"PCNP",
"PCNX",
"PCNXL2",
"PCNXL4",
"PCSK1",
"PCSK6",
"PCTP",
"PDCD1",
"PDCD1LG2",
"PDCD4-AS1",
"PDCD6IP",
"PDCL",
"PDCL3",
"PDE10A",
"PDE11A",
"PDE12",
"PDE2A",
"PDE3A",
"PDE3B",
"PDE4DIP",
"PDE6C",
"PDE6D",
"PDE6G",
"PDE7A",
"PDE8A",
"PDE8B",
"PDGFB",
"PDHA1",
"PDHX",
"PDIK1L",
"PDLIM4",
"PDLIM5",
"PDP1",
"PDP2",
"PDS5A",
"PDSS2",
"PDXDC1",
"PDXDC2P",
"PDZK1",
"PDZK1IP1",
"PDZK1P1",
"PEAK1",
"PEBP1",
"PECAM1",
"PECR",
"PELI1",
"PELI2",
"PELP1",
"PEMT",
"PERP",
"PET117",
"PEX11G",
"PEX12",
"PEX13",
"PEX16",
"PEX2",
"PEX26",
"PEX7",
"PF4",
"PFDN1",
"PFDN4",
"PFDN5",
"PFKP",
"PGAM1",
"PGAM2",
"PGAM5",
"PGBD5",
"PGD",
"PGLS",
"PGM1",
"PGM5P2",
"PGPEP1",
"PGPEP1L",
"PGRMC2",
"PHACTR1",
"PHACTR3",
"PHB",
"PHC1",
"PHC2",
"PHEX",
"PHF10",
"PHF13",
"PHF14",
"PHF21A",
"PHF24",
"PHF3",
"PHF6",
"PHF8",
"PHGDH",
"PHKA2",
"PHKB",
"PHLDA1",
"PHLDA3",
"PHLDB3",
"PHLPP1",
"PHLPP2",
"PHOSPHO2-KLHL23",
"PHTF1",
"PHTF2",
"PHYHD1",
"PI4KB",
"PIAS2",
"PICALM",
"PID1",
"PIGG",
"PIGK",
"PIGR",
"PIGZ",
"PIK3AP1",
"PIK3C2B",
"PIK3C3",
"PIK3IP1",
"PIK3IP1-AS1",
"PIK3R1",
"PIK3R3",
"PIM1",
"PIM3",
"PIN4",
"PINX1",
"PIP",
"PIP5K1P1",
"PIPOX",
"PISD",
"PITPNC1",
"PITPNM2",
"PITPNM3",
"PITX2",
"PITX3",
"PJA2",
"PKD1L1",
"PKD1L3",
"PKD2",
"PKDREJ",
"PKIA",
"PKIB",
"PKM",
"PKMYT1",
"PKN2",
"PKN2-AS1",
"PKN3",
"PKNOX1",
"PKP1",
"PKP2",
"PKP4",
"PLA2G10",
"PLA2G12A",
"PLA2G15",
"PLA2G1B",
"PLA2G4E",
"PLA2G6",
"PLA2R1",
"PLAC8L1",
"PLAUR",
"PLBD1",
"PLCB4",
"PLCD4",
"PLCE1",
"PLCG1-AS1",
"PLD1",
"PLD5",
"PLD6",
"PLEK2",
"PLEKHA1",
"PLEKHA3",
"PLEKHA5",
"PLEKHA7",
"PLEKHA8",
"PLEKHA8P1",
"PLEKHD1",
"PLEKHF1",
"PLEKHF2",
"PLEKHG3",
"PLEKHG6",
"PLEKHG7",
"PLEKHH1",
"PLEKHM1",
"PLEKHO1",
"PLEKHO2",
"PLEKHS1",
"PLET1",
"PLGLB2",
"PLGRKT",
"PLK3",
"PLLP",
"PLOD1",
"PLOD2",
"PLP1",
"PLRG1",
"PLSCR2",
"PLSCR3",
"PLSCR4",
"PLXDC2",
"PM20D1",
"PM20D2",
"PMAIP1",
"PMFBP1",
"PML",
"PMS2P5",
"PNLIPRP3",
"PNN",
"PNP",
"PNPLA4",
"PNPLA8",
"PNPT1",
"PNRC1",
"POC1B",
"POC1B-GALNT4",
"POC5",
"POGK",
"POGZ",
"POLE2",
"POLI",
"POLM",
"POLQ",
"POLR2D",
"POLR2E",
"POLR2M",
"POLR3B",
"POLR3E",
"POM121",
"POMP",
"POMT1",
"PON2",
"PON3",
"POP1",
"POP7",
"POR",
"PORCN",
"POT1-AS1",
"POTEE",
"POTEF",
"POTEKP",
"POU2F1",
"POU2F2",
"POU3F1",
"POU3F2",
"POU6F1",
"PPA1",
"PPA2",
"PPAP2B",
"PPAP2C",
"PPARG",
"PPCDC",
"PPFIA1",
"PPFIBP1",
"PPHLN1",
"PPIA",
"PPIC",
"PPID",
"PPIF",
"PPIL6",
"PPM1A",
"PPM1B",
"PPM1D",
"PPM1E",
"PPM1F",
"PPM1G",
"PPM1H",
"PPM1L",
"PPM1M",
"PPP1CB",
"PPP1R12A",
"PPP1R14B",
"PPP1R14C",
"PPP1R15B",
"PPP1R18",
"PPP1R1C",
"PPP1R2",
"PPP1R26-AS1",
"PPP1R32",
"PPP1R35",
"PPP1R36",
"PPP1R3B",
"PPP1R3E",
"PPP1R3F",
"PPP1R8",
"PPP1R9B",
"PPP2CA",
"PPP2R2A",
"PPP2R3B",
"PPP2R3C",
"PPP2R5C",
"PPP2R5D",
"PPP2R5E",
"PPP3CA",
"PPP3R1",
"PPP4R1",
"PPP5C",
"PPP6R3",
"PPRC1",
"PQLC1",
"PQLC2",
"PRB3",
"PRC1-AS1",
"PRCAT47",
"PRCC",
"PRCP",
"PRDM15",
"PRDM2",
"PRDM4",
"PRDM5",
"PRDM6",
"PRDX3",
"PRDX5",
"PRELID2",
"PRG2",
"PRICKLE2",
"PRICKLE2-AS3",
"PRICKLE3",
"PRIM2",
"PRKAB2",
"PRKACB",
"PRKAG2",
"PRKAR1A",
"PRKAR1B",
"PRKCA",
"PRKCA-AS1",
"PRKCD",
"PRKCDBP",
"PRKCE",
"PRKCG",
"PRKCH",
"PRKCI",
"PRKG1-AS1",
"PRKRA",
"PRKRIR",
"PRKX",
"PRKX-AS1",
"PRLH",
"PRMT1",
"PRMT2",
"PRMT9",
"PRNCR1",
"PRNP",
"PROC",
"PROM2",
"PROP1",
"PROSC",
"PROSER2-AS1",
"PRPF38B",
"PRPF39",
"PRPSAP1",
"PRR15L",
"PRR26",
"PRRC1",
"PRRC2A",
"PRRC2B",
"PRRG4",
"PRSS12",
"PRSS16",
"PRSS22",
"PRSS23",
"PRSS3",
"PRSS33",
"PRSS37",
"PRSS48",
"PRTG",
"PRUNE2",
"PSAT1",
"PSCA",
"PSD2",
"PSD4",
"PSEN1",
"PSEN2",
"PSG9",
"PSIP1",
"PSKH1",
"PSMA1",
"PSMA5",
"PSMB1",
"PSMB3",
"PSMB8-AS1",
"PSMD11",
"PSMD2",
"PSMD4",
"PSMD5",
"PSMD6-AS2",
"PSMD7",
"PSMG2",
"PSMG3-AS1",
"PSMG4",
"PTAR1",
"PTBP1",
"PTBP2",
"PTBP3",
"PTCH1",
"PTDSS1",
"PTER",
"PTGDR2",
"PTGDS",
"PTGER2",
"PTGER4",
"PTGER4P2-CDK2AP2P2",
"PTGES",
"PTGFRN",
"PTGR2",
"PTH",
"PTH1R",
"PTK2",
"PTK6",
"PTMA",
"PTOV1-AS1",
"PTP4A1",
"PTP4A2",
"PTP4A3",
"PTPMT1",
"PTPN11",
"PTPN12",
"PTPN13",
"PTPN18",
"PTPN2",
"PTPN21",
"PTPN22",
"PTPN3",
"PTPN4",
"PTPN7",
"PTPN9",
"PTPRF",
"PTPRG",
"PTPRH",
"PTPRK",
"PTPRO",
"PTPRZ1",
"PTRF",
"PTRH1",
"PTTG1IP",
"PTX4",
"PUM1",
"PUM2",
"PURB",
"PUS1",
"PUS10",
"PUS3",
"PUS7",
"PVT1",
"PWP1",
"PWWP2A",
"PWWP2B",
"PXDC1",
"PXDN",
"PXMP4",
"PXYLP1",
"PYCR2",
"PYGL",
"PYROXD1",
"PYURF",
"PYY2",
"QKI",
"QSER1",
"QSOX1",
"QTRT1",
"RAB10",
"RAB11A",
"RAB11FIP1",
"RAB11FIP2",
"RAB11FIP3",
"RAB14",
"RAB15",
"RAB19",
"RAB22A",
"RAB27A",
"RAB27B",
"RAB29",
"RAB2A",
"RAB2B",
"RAB31",
"RAB32",
"RAB33A",
"RAB33B",
"RAB36",
"RAB38",
"RAB39B",
"RAB40AL",
"RAB40B",
"RAB40C",
"RAB6A",
"RAB6B",
"RAB6C",
"RAB9B",
"RABAC1",
"RABEPK",
"RABGEF1",
"RACGAP1",
"RAD18",
"RAD21",
"RAD21-AS1",
"RAD23B",
"RAD50",
"RAD51AP1",
"RAD51B",
"RAD52",
"RAD54L2",
"RAET1E",
"RAET1E-AS1",
"RAET1G",
"RAI1-AS1",
"RALA",
"RALB",
"RALBP1",
"RALGAPA1",
"RALGAPA2",
"RALGAPB",
"RALGPS1",
"RALGPS2",
"RAMP3",
"RAN",
"RANBP3L",
"RANGRF",
"RAP1A",
"RAP1B",
"RAP1GDS1",
"RAP2A",
"RAPGEF1",
"RAPGEF2",
"RAPGEF3",
"RAPGEF5",
"RAPSN",
"RARA",
"RARRES1",
"RARRES2",
"RARS",
"RASA1",
"RASA2",
"RASA4CP",
"RASAL2-AS1",
"RASEF",
"RASGRP1",
"RASL10A",
"RASL11A",
"RASSF3",
"RASSF5",
"RASSF8",
"RASSF9",
"RB1CC1",
"RBBP5",
"RBBP6",
"RBBP8",
"RBCK1",
"RBM17",
"RBM25",
"RBM27",
"RBM34",
"RBM42",
"RBM44",
"RBM46",
"RBM47",
"RBM48",
"RBMS1",
"RBMS2",
"RBMX2",
"RBMXL1",
"RBP2",
"RBPMS",
"RBPMS2",
"RBX1",
"RC3H1",
"RCBTB1",
"RCBTB2",
"RCC2",
"RCHY1",
"RCN1",
"RCN2",
"RCOR1",
"RCOR2",
"RCOR3",
"RDH10-AS1",
"RDH5",
"RDX",
"REEP3",
"REEP5",
"RELB",
"RELT",
"RENBP",
"REPS2",
"RER1",
"RERE",
"REST",
"REV1",
"REV3L",
"REXO1L2P",
"REXO2",
"RFC2",
"RFC3",
"RFC4",
"RFPL3S",
"RFT1",
"RFTN1",
"RFWD2",
"RFWD3",
"RFX3-AS1",
"RFX7",
"RFX8",
"RGMB",
"RGPD8",
"RGS10",
"RGS12",
"RGS14",
"RGS17",
"RGS20",
"RGS3",
"RGS7",
"RGS9BP",
"RHBDD1",
"RHBDL2",
"RHBG",
"RHCE",
"RHEBL1",
"RHOB",
"RHOBTB2",
"RHOBTB3",
"RHOD",
"RHOQ",
"RHOT1",
"RHOXF2",
"RHPN1-AS1",
"RIC1",
"RICTOR",
"RIF1",
"RIMS2",
"RIMS3",
"RIN2",
"RIOK1",
"RIPK3",
"RIPK4",
"RIPPLY2",
"RIPPLY3",
"RIT1",
"RLBP1",
"RLIM",
"RLN1",
"RLTPR",
"RMDN1",
"RMDN2",
"RMDN3",
"RMI2",
"RMND5A",
"RMST",
"RN7SL2",
"RNASE2",
"RNASEH1",
"RNASEH2B",
"RNASEH2B-AS1",
"RNASET2",
"RND1",
"RND3",
"RNF10",
"RNF11",
"RNF130",
"RNF135",
"RNF138",
"RNF139-AS1",
"RNF14",
"RNF144A",
"RNF144B",
"RNF145",
"RNF146",
"RNF165",
"RNF168",
"RNF169",
"RNF183",
"RNF185",
"RNF187",
"RNF19A",
"RNF19B",
"RNF216",
"RNF219",
"RNF24",
"RNF31",
"RNF32",
"RNF34",
"RNF38",
"RNF39",
"RNF6",
"RNFT1",
"RNH1",
"RNU1-2",
"RNU1-28P",
"RNU11",
"RNU5A-1",
"RNU5B-1",
"RNU6ATAC",
"RNVU1-1",
"RNVU1-15",
"RNVU1-18",
"RNVU1-19",
"RNVU1-3",
"RNVU1-8",
"RNY1",
"RNY5",
"ROBO4",
"ROCK1",
"ROM1",
"ROR2",
"RORC",
"ROS1",
"RPE65",
"RPEL1",
"RPGRIP1",
"RPH3AL",
"RPL13AP20",
"RPL13P5",
"RPL21P44",
"RPL22L1",
"RPL23AP53",
"RPL28",
"RPL29",
"RPL31",
"RPL7",
"RPLP1",
"RPP14",
"RPP25",
"RPP25L",
"RPRD1A",
"RPRD2",
"RPS12",
"RPS13",
"RPS14",
"RPS16",
"RPS19",
"RPS19BP1",
"RPS23",
"RPS24",
"RPS27L",
"RPS29",
"RPS2P32",
"RPS6KA1",
"RPS6KA2",
"RPS6KA2-AS1",
"RPS6KA3",
"RPS6KA4",
"RPS6KA5",
"RPS6KB1",
"RPS6KC1",
"RPS9",
"RPSA",
"RPSAP58",
"RPSAP9",
"RPUSD1",
"RPUSD2",
"RQCD1",
"RRAS2",
"RRBP1",
"RREB1",
"RRM1",
"RRN3P1",
"RRN3P2",
"RRP1",
"RRP12",
"RRP15",
"RRP1B",
"RRP7A",
"RS1",
"RSBN1",
"RSL24D1",
"RSPH14",
"RSPH3",
"RSPH4A",
"RSPH9",
"RSRP1",
"RSU1",
"RTBDN",
"RTCA",
"RTF1",
"RTFDC1",
"RTKN2",
"RTN2",
"RTN4",
"RTN4RL1",
"RUFY3",
"RUNDC3A",
"RUNDC3B",
"RUNX1",
"RUNX2",
"RUVBL2",
"RWDD1",
"RWDD2B",
"RXFP4",
"RYR3",
"S100A1",
"S100A10",
"S100A11",
"S100A2",
"S100A5",
"SAAL1",
"SACS",
"SAE1",
"SALRNA1",
"SAMD1",
"SAMD12",
"SAMD13",
"SAMD15",
"SAMD8",
"SAMHD1",
"SAMM50",
"SAP130",
"SAP30",
"SAP30L",
"SAP30L-AS1",
"SAR1B",
"SARS",
"SART1",
"SART3",
"SAYSD1",
"SBDS",
"SBF2",
"SBF2-AS1",
"SBK1",
"SBNO1",
"SC5D",
"SCAF11",
"SCAF4",
"SCAF8",
"SCAND2P",
"SCAPER",
"SCART1",
"SCD",
"SCFD2",
"SCG3",
"SCGB2B2",
"SCGB3A1",
"SCHIP1",
"SCIMP",
"SCIN",
"SCLT1",
"SCMH1",
"SCN4B",
"SCN8A",
"SCNN1D",
"SCO1",
"SCOC",
"SCP2",
"SCRG1",
"SCRIB",
"SCUBE3",
"SDAD1",
"SDC1",
"SDC3",
"SDC4",
"SDCBP2-AS1",
"SDE2",
"SDF2L1",
"SDHAF2",
"SDHAP2",
"SDHB",
"SDHC",
"SDHD",
"SDK1",
"SDPR",
"SDS",
"SEC11A",
"SEC14L5",
"SEC22B",
"SEC23A",
"SEC24B-AS1",
"SEC24C",
"SEC24D",
"SEC31A",
"SEC61A1",
"SEC61B",
"SEC62",
"SEC63",
"SECISBP2L",
"SEL1L3",
"SELK",
"SELM",
"SELT",
"SEMA3A",
"SEMA3C",
"SEMA4B",
"SEMA4G",
"SEMA6A",
"SEMA6C",
"SEMA7A",
"SEMG2",
"SENCR",
"SENP7",
"SEP15",
"SEPHS2",
"SEPSECS",
"SEPSECS-AS1",
"SEPT11",
"SEPT4",
"SEPT7",
"SEPT7-AS1",
"SEPT7P2",
"SEPT7P9",
"SEPT9",
"SEPW1",
"SERBP1",
"SERINC2",
"SERINC5",
"SERP2",
"SERPINA12",
"SERPINA3",
"SERPINA9",
"SERPINB1",
"SERPINB2",
"SERPINB5",
"SERPINB8",
"SERPINC1",
"SERPINE1",
"SERPINE2",
"SERPINE3",
"SERPINF1",
"SERPINH1",
"SERTAD4",
"SESTD1",
"SETBP1",
"SETD1A",
"SETD8",
"SEZ6",
"SF1",
"SF3B1",
"SF3B5",
"SFN",
"SFPQ",
"SFR1",
"SFRP1",
"SFRP5",
"SFSWAP",
"SFTA1P",
"SFTPB",
"SFXN1",
"SFXN3",
"SGCA",
"SGMS2",
"SGOL2",
"SGPP1",
"SGPP2",
"SH2B1",
"SH2B2",
"SH2D3C",
"SH2D5",
"SH2D6",
"SH3BP4",
"SH3BP5L",
"SH3D19",
"SH3GLB1",
"SH3RF1",
"SH3TC1",
"SH3TC2",
"SHANK1",
"SHANK2",
"SHC3",
"SHCBP1L",
"SHISA9",
"SHQ1",
"SHROOM2",
"SIAH2",
"SIGLEC15",
"SIK1",
"SIN3A",
"SIPA1L2",
"SIRT4",
"SIRT5",
"SKA2",
"SKA3",
"SKAP2",
"SKIDA1",
"SKIL",
"SKP1",
"SKP2",
"SLAIN2",
"SLAMF9",
"SLBP",
"SLC10A1",
"SLC10A7",
"SLC11A2",
"SLC12A1",
"SLC12A5",
"SLC12A7",
"SLC12A8",
"SLC13A4",
"SLC13A5",
"SLC15A2",
"SLC16A11",
"SLC16A14",
"SLC16A2",
"SLC16A8",
"SLC18A1",
"SLC19A1",
"SLC19A2",
"SLC1A3",
"SLC1A4",
"SLC1A5",
"SLC20A1",
"SLC20A2",
"SLC22A13",
"SLC22A14",
"SLC22A15",
"SLC22A4",
"SLC22A5",
"SLC23A2",
"SLC23A3",
"SLC24A4",
"SLC25A10",
"SLC25A14",
"SLC25A19",
"SLC25A24",
"SLC25A25",
"SLC25A28",
"SLC25A3",
"SLC25A37",
"SLC25A38",
"SLC25A43",
"SLC25A5",
"SLC25A5-AS1",
"SLC25A51",
"SLC26A1",
"SLC26A2",
"SLC26A8",
"SLC26A9",
"SLC27A3",
"SLC27A4",
"SLC27A5",
"SLC27A6",
"SLC28A1",
"SLC29A1",
"SLC29A3",
"SLC2A8",
"SLC30A1",
"SLC30A4",
"SLC30A5",
"SLC30A8",
"SLC30A9",
"SLC33A1",
"SLC35B1",
"SLC35B2",
"SLC35B3",
"SLC35B4",
"SLC35C1",
"SLC35D1",
"SLC35E1",
"SLC35E3",
"SLC35F2",
"SLC35F6",
"SLC35G1",
"SLC35G2",
"SLC35G6",
"SLC36A4",
"SLC37A1",
"SLC37A3",
"SLC38A1",
"SLC38A2",
"SLC38A4",
"SLC38A5",
"SLC38A8",
"SLC39A9",
"SLC41A1",
"SLC41A2",
"SLC41A3",
"SLC43A1",
"SLC43A3",
"SLC44A1",
"SLC45A3",
"SLC45A4",
"SLC46A3",
"SLC47A2",
"SLC48A1",
"SLC4A11",
"SLC4A3",
"SLC4A4",
"SLC4A5",
"SLC4A9",
"SLC52A2",
"SLC5A10",
"SLC5A4",
"SLC5A9",
"SLC6A12",
"SLC6A13",
"SLC6A15",
"SLC6A6",
"SLC6A8",
"SLC6A9",
"SLC7A11",
"SLC7A13",
"SLC7A5",
"SLC7A7",
"SLC8A1-AS1",
"SLC9A1",
"SLC9A2",
"SLC9A3R1",
"SLC9A3R2",
"SLC9A6",
"SLC9C1",
"SLCO3A1",
"SLF1",
"SLF2",
"SLFN5",
"SLFNL1-AS1",
"SLITRK5",
"SLK",
"SLMAP",
"SLMO1",
"SLMO2-ATP5E",
"SLTM",
"SMAD1",
"SMAD1-AS2",
"SMAD2",
"SMAD3",
"SMAD4",
"SMAD9",
"SMAGP",
"SMAP1",
"SMARCA4",
"SMARCB1",
"SMARCC2",
"SMARCD2",
"SMC1B",
"SMC2",
"SMC3",
"SMCO2",
"SMCO3",
"SMG1",
"SMG1P2",
"SMG1P3",
"SMG1P5",
"SMIM14",
"SMIM2-AS1",
"SMIM20",
"SMIM4",
"SMIM5",
"SMN1",
"SMPD3",
"SMPDL3A",
"SMS",
"SMU1",
"SMURF2",
"SMYD2",
"SMYD5",
"SNAI1",
"SNAI2",
"SNAP47",
"SNAPC1",
"SNED1",
"SNHG10",
"SNHG6",
"SNORA21",
"SNORA51",
"SNORA53",
"SNORA71A",
"SNORD101",
"SNORD115-47",
"SNORD14A",
"SNORD14E",
"SNORD51",
"SNORD52",
"SNORD54",
"SNORD56B",
"SNORD59B",
"SNORD64",
"SNORD7",
"SNORD89",
"SNORD93",
"SNRNP40",
"SNRNP48",
"SNRPA1",
"SNRPB",
"SNRPC",
"SNRPD1",
"SNTA1",
"SNTB2",
"SNU13",
"SNX11",
"SNX17",
"SNX18",
"SNX2",
"SNX22",
"SNX24",
"SNX29P1",
"SNX3",
"SNX30",
"SNX31",
"SNX5",
"SNX6",
"SNX7",
"SNX9",
"SOAT1",
"SOCS1",
"SOCS5",
"SOCS6",
"SOD1",
"SOD2",
"SOGA1",
"SOGA3",
"SORBS1",
"SORCS1",
"SORCS2",
"SORL1",
"SOS1",
"SOS2",
"SOWAHB",
"SOWAHD",
"SOX10",
"SOX12",
"SOX3",
"SOX4",
"SP1",
"SP110",
"SP2",
"SP2-AS1",
"SP3",
"SP4",
"SP8",
"SPAG1",
"SPAG5-AS1",
"SPAG6",
"SPAG9",
"SPARCL1",
"SPAST",
"SPATA12",
"SPATA18",
"SPATA25",
"SPATA32",
"SPATA5",
"SPATA5L1",
"SPATA9",
"SPATS1",
"SPATS2",
"SPATS2L",
"SPCS3",
"SPDEF",
"SPDYE2B",
"SPEF1",
"SPG20",
"SPG20-AS1",
"SPG7",
"SPI1",
"SPIDR",
"SPIN1",
"SPIN2A",
"SPIN2B",
"SPIN3",
"SPIN4",
"SPINK14",
"SPINK4",
"SPINK6",
"SPINK8",
"SPINT1",
"SPINT2",
"SPINT4",
"SPIRE1",
"SPIRE2",
"SPOCD1",
"SPON1",
"SPOPL",
"SPPL2A",
"SPPL2B",
"SPR",
"SPRED1",
"SPRED2",
"SPRY2",
"SPRYD7",
"SPTBN1",
"SPTBN2",
"SPTLC3",
"SPTSSA",
"SPTSSB",
"SPTY2D1",
"SPTY2D1-AS1",
"SPX",
"SQLE",
"SQRDL",
"SRBD1",
"SRD5A3-AS1",
"SREK1",
"SRGAP1",
"SRGAP2-AS1",
"SRI",
"SRL",
"SRMS",
"SRP54",
"SRP72",
"SRP9",
"SRPK1",
"SRRM1",
"SRRM2",
"SRRM2-AS1",
"SRRM3",
"SRSF1",
"SRSF10",
"SRSF12",
"SRSF4",
"SRSF6",
"SSBP2",
"SSBP3",
"SSBP4",
"SSC4D",
"SSFA2",
"SSMEM1",
"SSPN",
"SSR1",
"SSR2",
"SSR3",
"SSTR1",
"SSTR2",
"SSTR5",
"ST20-AS1",
"ST20-MTHFS",
"ST3GAL1",
"ST3GAL4",
"ST6GAL1",
"ST6GALNAC2",
"ST8SIA2",
"ST8SIA4",
"ST8SIA6-AS1",
"STAG1",
"STAG3",
"STAG3L1",
"STAG3L3",
"STAM",
"STAM2",
"STAMBP",
"STAP2",
"STARD10",
"STARD13-AS",
"STARD3NL",
"STARD6",
"STARD7",
"STAT1",
"STAT3",
"STAT5B",
"STAT6",
"STAU1",
"STAU2",
"STC2",
"STEAP3",
"STEAP4",
"STIM1",
"STIM2",
"STIP1",
"STK11IP",
"STK17A",
"STK26",
"STK3",
"STK38L",
"STK39",
"STMN1",
"STMN3",
"STOML1",
"STOML2",
"STOML3",
"STON1-GTF2A1L",
"STOX2",
"STPG2",
"STRA6",
"STRAP",
"STRC",
"STRIP2",
"STRN",
"STS",
"STT3B",
"STUB1",
"STX12",
"STX16",
"STX18-AS1",
"STX1A",
"STX4",
"STX5",
"STX8",
"STXBP1",
"STXBP3",
"STXBP5",
"STXBP5L",
"STYK1",
"SUB1",
"SUCLG1",
"SUCO",
"SUGP2",
"SUGT1P1",
"SULF2",
"SUMO1",
"SUMO1P1",
"SUMO2",
"SUN5",
"SUPT3H",
"SUPV3L1",
"SUSD1",
"SUSD3",
"SUSD6",
"SUV39H1",
"SUV39H2",
"SUV420H2",
"SUZ12",
"SVIL",
"SVIL-AS1",
"SVILP1",
"SVIP",
"SVOPL",
"SWAP70",
"SWI5",
"SYBU",
"SYCE1L",
"SYDE2",
"SYF2",
"SYN2",
"SYN3",
"SYNCRIP",
"SYNE3",
"SYNE4",
"SYPL1",
"SYPL2",
"SYT1",
"SYT10",
"SYT12",
"SYT14",
"SYT15",
"SYT2",
"SYTL2",
"SYTL3",
"SZRD1",
"TACC1",
"TACC3",
"TACR1",
"TACR2",
"TACSTD2",
"TADA1",
"TADA2A",
"TADA3",
"TAF11",
"TAF12",
"TAF13",
"TAF1B",
"TAF4B",
"TAF6L",
"TAF8",
"TAF9B",
"TAGLN2",
"TANC1",
"TAOK3",
"TAP2",
"TAPBP",
"TAPT1",
"TARBP2",
"TAS2R40",
"TAS2R42",
"TAS2R5",
"TAX1BP1",
"TBC1D1",
"TBC1D14",
"TBC1D15",
"TBC1D2",
"TBC1D22A",
"TBC1D29",
"TBC1D30",
"TBC1D32",
"TBC1D4",
"TBC1D5",
"TBC1D8",
"TBC1D9",
"TBC1D9B",
"TBCA",
"TBCB",
"TBCC",
"TBCEL",
"TBCK",
"TBK1",
"TBPL1",
"TBPL2",
"TBRG1",
"TBX1",
"TBX15",
"TBX18",
"TBX4",
"TCAF1",
"TCAF2",
"TCEA1",
"TCEA2",
"TCEAL1",
"TCEAL3",
"TCEAL4",
"TCEB1",
"TCEB3",
"TCERG1",
"TCF20",
"TCF24",
"TCF7",
"TCF7L2",
"TCFL5",
"TCHH",
"TCHP",
"TCIRG1",
"TCN1",
"TCONS_00029157",
"TCP10L",
"TCP11L2",
"TCTN1",
"TDP1",
"TDRD10",
"TDRD3",
"TDRD5",
"TDRP",
"TEAD3",
"TEAD4",
"TEC",
"TECPR2",
"TEF",
"TEP1",
"TERC",
"TERF2",
"TERF2IP",
"TERT",
"TES",
"TESK1",
"TET1",
"TET2",
"TET2-AS1",
"TET3",
"TEX10",
"TEX12",
"TEX13B",
"TEX2",
"TEX21P",
"TEX261",
"TEX264",
"TEX30",
"TEX38",
"TFAP2A",
"TFAP2A-AS1",
"TFAP2E",
"TFB1M",
"TFCP2",
"TFDP1",
"TFDP2",
"TFG",
"TFIP11",
"TFRC",
"TGDS",
"TGFA",
"TGFB2-AS1",
"TGFB3",
"TGFBR1",
"TGM1",
"TGM2",
"TGM4",
"TGM6",
"TGS1",
"TH2LCRR",
"THAP10",
"THAP4",
"THAP6",
"THAP8",
"THAP9",
"THBD",
"THBS1",
"THBS2",
"THEM4",
"THEMIS2",
"THNSL2",
"THOC2",
"THOC3",
"THOC7-AS1",
"THPO",
"THRAP3",
"THRB-AS1",
"THRSP",
"THSD4",
"THSD4-AS1",
"THTPA",
"THUMPD1",
"THUMPD2",
"THUMPD3",
"TIA1",
"TIAL1",
"TIAM1",
"TIAM2",
"TICAM1",
"TICAM2",
"TIGD2",
"TIGD3",
"TIMELESS",
"TIMM21",
"TIMM44",
"TIMM8A",
"TIMMDC1",
"TINAGL1",
"TIPARP",
"TIPRL",
"TIRAP",
"TJP1",
"TJP2",
"TKTL1",
"TLCD2",
"TLE3",
"TLE4",
"TLK1",
"TLL1",
"TLR4",
"TLX1NB",
"TLX2",
"TLX3",
"TM2D1",
"TM4SF1-AS1",
"TM4SF18",
"TM4SF19-TCTEX1D2",
"TM4SF20",
"TM7SF3",
"TM9SF2",
"TMBIM1",
"TMC2",
"TMCO2",
"TMCO3",
"TMCO4",
"TMED10",
"TMED3",
"TMED6",
"TMEM101",
"TMEM105",
"TMEM106C",
"TMEM11",
"TMEM117",
"TMEM121",
"TMEM123",
"TMEM126B",
"TMEM128",
"TMEM129",
"TMEM130",
"TMEM131",
"TMEM135",
"TMEM140",
"TMEM14A",
"TMEM150A",
"TMEM154",
"TMEM158",
"TMEM167A",
"TMEM167B",
"TMEM168",
"TMEM17",
"TMEM171",
"TMEM178A",
"TMEM178B",
"TMEM18",
"TMEM182",
"TMEM184B",
"TMEM184C",
"TMEM186",
"TMEM19",
"TMEM191B",
"TMEM192",
"TMEM201",
"TMEM204",
"TMEM212-AS1",
"TMEM229B",
"TMEM230",
"TMEM231",
"TMEM232",
"TMEM236",
"TMEM242",
"TMEM243",
"TMEM245",
"TMEM251",
"TMEM260",
"TMEM263",
"TMEM27",
"TMEM30A",
"TMEM30B",
"TMEM30C",
"TMEM31",
"TMEM38A",
"TMEM39A",
"TMEM41B",
"TMEM44",
"TMEM45A",
"TMEM45B",
"TMEM51",
"TMEM55A",
"TMEM65",
"TMEM67",
"TMEM69",
"TMEM70",
"TMEM82",
"TMEM87B",
"TMEM9",
"TMEM92-AS1",
"TMIE",
"TMOD1",
"TMOD2",
"TMOD3",
"TMPO-AS1",
"TMPRSS11E",
"TMPRSS2",
"TMPRSS5",
"TMSB10",
"TMSB4X",
"TMTC2",
"TMX4",
"TNFAIP2",
"TNFAIP8",
"TNFAIP8L3",
"TNFRSF14",
"TNFRSF21",
"TNFSF12",
"TNFSF13",
"TNFSF13B",
"TNFSF9",
"TNIK",
"TNIP1",
"TNIP3",
"TNK2",
"TNKS",
"TNNC2",
"TNNT2",
"TNPO1",
"TNPO2",
"TNRC18",
"TNRC6B",
"TNRC6C",
"TNS1",
"TNS3",
"TNS4",
"TOB1",
"TOB2",
"TOM1L1",
"TOMM20",
"TOMM20L",
"TOMM34",
"TOP2B",
"TOPBP1",
"TOR1AIP2",
"TOR3A",
"TOX",
"TOX2",
"TP53BP2",
"TP53INP1",
"TP53INP2",
"TP53TG1",
"TPD52",
"TPH1",
"TPM1",
"TPM3P9",
"TPP2",
"TPPP",
"TPRA1",
"TPRG1-AS1",
"TPTE",
"TPTE2P1",
"TPTE2P3",
"TPTE2P5",
"TPX2",
"TRA2B",
"TRAF3IP1",
"TRAF3IP3",
"TRAF6",
"TRAK1",
"TRAM2-AS1",
"TRAPPC10",
"TRAPPC11",
"TRAPPC12",
"TRAPPC6B",
"TRAPPC9",
"TREH",
"TRERF1",
"TRERNA1",
"TREX2",
"TRIB1",
"TRIB2",
"TRIB3",
"TRIM11",
"TRIM13",
"TRIM16",
"TRIM16L",
"TRIM25",
"TRIM27",
"TRIM29",
"TRIM3",
"TRIM31",
"TRIM35",
"TRIM38",
"TRIM44",
"TRIM45",
"TRIM47",
"TRIM61",
"TRIM62",
"TRIM7",
"TRIM71",
"TRIM8",
"TRIO",
"TRIP11",
"TRIP12",
"TRIP13",
"TRIP4",
"TRIQK",
"TRIT1",
"TRMT1L",
"TRMT61B",
"TRNAU1AP",
"TRNP1",
"TRNT1",
"TRPA1",
"TRPC5",
"TRPC7",
"TRPM2",
"TRPM3",
"TRPM5",
"TRPM7",
"TRPV1",
"TSC22D1",
"TSC22D1-AS1",
"TSC22D2",
"TSEN15",
"TSEN2",
"TSEN54",
"TSGA10",
"TSHR",
"TSHZ3",
"TSN",
"TSNARE1",
"TSPAN11",
"TSPAN12",
"TSPAN13",
"TSPAN14",
"TSPAN2",
"TSPAN5",
"TSPAN9",
"TSPY26P",
"TSR2",
"TSSC1",
"TSSK3",
"TTBK2",
"TTC1",
"TTC13",
"TTC14",
"TTC23L",
"TTC25",
"TTC26",
"TTC32",
"TTC37",
"TTC39A",
"TTC39B",
"TTC39C",
"TTC39C-AS1",
"TTC3P1",
"TTC6",
"TTC7A",
"TTC8",
"TTC9",
"TTC9B",
"TTC9C",
"TTF1",
"TTI1",
"TTK",
"TTLL1",
"TTLL10",
"TTLL13P",
"TTLL4",
"TTN",
"TUBA1A",
"TUBA3D",
"TUBA3E",
"TUBA8",
"TUBB",
"TUBGCP2",
"TUBGCP5",
"TUFM",
"TULP1",
"TULP2",
"TULP3",
"TULP4",
"TUSC1",
"TWF1",
"TWIST1",
"TWSG1",
"TXLNA",
"TXLNG",
"TXN2",
"TXNDC15",
"TXNDC16",
"TXNIP",
"TXNL1",
"TXNRD2",
"TYW1",
"TYW1B",
"U2AF1",
"UACA",
"UAP1",
"UBA2",
"UBA5",
"UBAC1",
"UBALD1",
"UBAP1",
"UBAP1L",
"UBAP2",
"UBASH3A",
"UBB",
"UBC",
"UBE2D2",
"UBE2D3",
"UBE2E3",
"UBE2G1",
"UBE2G2",
"UBE2H",
"UBE2I",
"UBE2J1",
"UBE2V1",
"UBE2W",
"UBE2Z",
"UBE3A",
"UBE3B",
"UBE3D",
"UBL3",
"UBLCP1",
"UBN2",
"UBOX5",
"UBOX5-AS1",
"UBP1",
"UBQLN4",
"UBR4",
"UBR5-AS1",
"UBR7",
"UBTF",
"UBXN10",
"UBXN7",
"UBXN8",
"UCA1",
"UCK1",
"UEVLD",
"UFD1L",
"UFM1",
"UFSP2",
"UGCG",
"UGGT1",
"UGGT2",
"UGP2",
"UGT2B15",
"UHMK1",
"UHRF2",
"ULBP2",
"UMAD1",
"UNC119B",
"UNC13C",
"UNC5B-AS1",
"UNC5C",
"UNK",
"UPF2",
"UPF3A",
"UPK1B",
"UPK3B",
"UPP1",
"UQCC3",
"UQCRC2",
"UQCRHL",
"UROC1",
"USH2A",
"USHBP1",
"USO1",
"USP12",
"USP12-AS1",
"USP13",
"USP15",
"USP18",
"USP19",
"USP22",
"USP3",
"USP32",
"USP36",
"USP38",
"USP39",
"USP4",
"USP40",
"USP42",
"USP46",
"USP46-AS1",
"USP47",
"USP51",
"USP54",
"USP6",
"USP6NL",
"USP7",
"USP8",
"USP9X",
"UST",
"UTAT33",
"UTP11L",
"UTP15",
"UTP23",
"UTP6",
"UTRN",
"UVRAG",
"UVSSA",
"UXS1",
"VAMP2",
"VAMP3",
"VAMP7",
"VANGL2",
"VARS2",
"VASP",
"VAV2",
"VAV3",
"VCP",
"VCPIP1",
"VCPKMT",
"VCX",
"VCX2",
"VDAC1",
"VDAC2",
"VDAC3",
"VDR",
"VEGFA",
"VEGFB",
"VEGFC",
"VEPH1",
"VEZF1",
"VHL",
"VILL",
"VIM",
"VLDLR",
"VMA21",
"VMP1",
"VN1R1",
"VPS11",
"VPS13C",
"VPS13D",
"VPS36",
"VPS37C",
"VPS37D",
"VPS4B",
"VPS53",
"VPS72",
"VSIG8",
"VSNL1",
"VTA1",
"VTRNA1-1",
"VTRNA2-1",
"VWA8",
"VWDE",
"WAC-AS1",
"WARS2",
"WAS",
"WASF1",
"WASF2",
"WASL",
"WBP2NL",
"WBP4",
"WDFY1",
"WDFY2",
"WDHD1",
"WDR1",
"WDR13",
"WDR26",
"WDR27",
"WDR36",
"WDR43",
"WDR44",
"WDR47",
"WDR48",
"WDR5",
"WDR60",
"WDR61",
"WDR63",
"WDR64",
"WDR66",
"WDR7",
"WDR70",
"WDR73",
"WDR74",
"WDR75",
"WDR89",
"WDR92",
"WDR93",
"WDSUB1",
"WDYHV1",
"WEE1",
"WFDC2",
"WFDC6",
"WHAMMP1",
"WIPF3",
"WIPI1",
"WISP1",
"WISP3",
"WNK1",
"WNK3",
"WNK4",
"WNT10B",
"WNT11",
"WNT16",
"WNT2",
"WNT3A",
"WNT4",
"WNT5A",
"WNT6",
"WNT7B",
"WRB",
"WRN",
"WT1",
"WTH3DI",
"WWC1",
"WWC2",
"WWOX",
"WWTR1",
"XAF1",
"XDH",
"XIAP",
"XIRP1",
"XK",
"XPA",
"XPNPEP1",
"XPNPEP3",
"XPO1",
"XPO4",
"XPO7",
"XRCC2",
"XRCC4",
"XRN2",
"XYLT2",
"YAP1",
"YARS2",
"YEATS4",
"YES1",
"YIF1B",
"YIPF4",
"YIPF5",
"YIPF6",
"YJEFN3",
"YME1L1",
"YPEL2",
"YPEL5",
"YTHDC1",
"YTHDF1",
"YTHDF2",
"YTHDF3",
"YWHAE",
"YWHAH",
"YWHAQ",
"YWHAZ",
"ZADH2",
"ZAR1",
"ZAR1L",
"ZBED3-AS1",
"ZBED4",
"ZBED5",
"ZBED5-AS1",
"ZBED9",
"ZBP1",
"ZBTB10",
"ZBTB11-AS1",
"ZBTB18",
"ZBTB2",
"ZBTB20",
"ZBTB3",
"ZBTB34",
"ZBTB38",
"ZBTB40",
"ZBTB41",
"ZBTB43",
"ZBTB44",
"ZBTB46-AS1",
"ZBTB5",
"ZBTB7A",
"ZBTB7B",
"ZBTB7C",
"ZBTB8A",
"ZBTB9",
"ZC2HC1A",
"ZC3H12B",
"ZC3H12C",
"ZC3H12D",
"ZC3H13",
"ZC3H15",
"ZC3H18",
"ZC3H3",
"ZC3H4",
"ZC3H6",
"ZC3H7A",
"ZC3HAV1",
"ZC3HC1",
"ZCCHC10",
"ZCCHC11",
"ZCCHC2",
"ZCCHC6",
"ZCCHC7",
"ZDBF2",
"ZDHHC14",
"ZDHHC17",
"ZDHHC18",
"ZDHHC2",
"ZDHHC22",
"ZDHHC4",
"ZDHHC5",
"ZDHHC7",
"ZDHHC8",
"ZFAND1",
"ZFAND4",
"ZFAND5",
"ZFAT",
"ZFC3H1",
"ZFHX2",
"ZFHX3",
"ZFP1",
"ZFP14",
"ZFP3",
"ZFP30",
"ZFP36L1",
"ZFP36L2",
"ZFP69",
"ZFP90",
"ZFP91",
"ZFP92",
"ZFPM1",
"ZFPM2",
"ZFR",
"ZFYVE1",
"ZFYVE16",
"ZFYVE26",
"ZFYVE27",
"ZHX1",
"ZHX2",
"ZHX3",
"ZIC2",
"ZIC3",
"ZIC4",
"ZIC5",
"ZKSCAN1",
"ZKSCAN5",
"ZMIZ2",
"ZMYM2",
"ZMYM4",
"ZMYM5",
"ZMYND11",
"ZMYND8",
"ZNF101",
"ZNF114",
"ZNF12",
"ZNF124",
"ZNF132",
"ZNF133",
"ZNF134",
"ZNF137P",
"ZNF14",
"ZNF141",
"ZNF143",
"ZNF146",
"ZNF160",
"ZNF165",
"ZNF169",
"ZNF175",
"ZNF181",
"ZNF182",
"ZNF184",
"ZNF189",
"ZNF195",
"ZNF2",
"ZNF202",
"ZNF213",
"ZNF214",
"ZNF215",
"ZNF217",
"ZNF226",
"ZNF23",
"ZNF232",
"ZNF233",
"ZNF234",
"ZNF251",
"ZNF260",
"ZNF263",
"ZNF267",
"ZNF268",
"ZNF273",
"ZNF277",
"ZNF280D",
"ZNF281",
"ZNF283",
"ZNF286A",
"ZNF292",
"ZNF317",
"ZNF322",
"ZNF324B",
"ZNF329",
"ZNF33A",
"ZNF34",
"ZNF35",
"ZNF367",
"ZNF37A",
"ZNF385C",
"ZNF391",
"ZNF397",
"ZNF398",
"ZNF404",
"ZNF407",
"ZNF419",
"ZNF420",
"ZNF429",
"ZNF430",
"ZNF438",
"ZNF444",
"ZNF445",
"ZNF451",
"ZNF462",
"ZNF467",
"ZNF469",
"ZNF474",
"ZNF483",
"ZNF486",
"ZNF487",
"ZNF496",
"ZNF503-AS2",
"ZNF507",
"ZNF518A",
"ZNF527",
"ZNF532",
"ZNF543",
"ZNF544",
"ZNF546",
"ZNF552",
"ZNF558",
"ZNF564",
"ZNF567",
"ZNF57",
"ZNF573",
"ZNF585B",
"ZNF586",
"ZNF587B",
"ZNF589",
"ZNF592",
"ZNF600",
"ZNF608",
"ZNF609",
"ZNF619",
"ZNF620",
"ZNF626",
"ZNF627",
"ZNF629",
"ZNF639",
"ZNF641",
"ZNF655",
"ZNF670",
"ZNF671",
"ZNF674-AS1",
"ZNF675",
"ZNF681",
"ZNF689",
"ZNF691",
"ZNF696",
"ZNF697",
"ZNF7",
"ZNF70",
"ZNF700",
"ZNF703",
"ZNF706",
"ZNF708",
"ZNF711",
"ZNF714",
"ZNF724P",
"ZNF732",
"ZNF746",
"ZNF747",
"ZNF750",
"ZNF76",
"ZNF764",
"ZNF765",
"ZNF767P",
"ZNF77",
"ZNF770",
"ZNF773",
"ZNF775",
"ZNF777",
"ZNF783",
"ZNF785",
"ZNF786",
"ZNF787",
"ZNF789",
"ZNF79",
"ZNF790",
"ZNF791",
"ZNF8",
"ZNF800",
"ZNF805",
"ZNF816-ZNF321P",
"ZNF821",
"ZNF826P",
"ZNF83",
"ZNF830",
"ZNF836",
"ZNF839",
"ZNF85",
"ZNF852",
"ZNF860",
"ZNF865",
"ZNF876P",
"ZNHIT2",
"ZNRD1-AS1",
"ZNRF2",
"ZNRF3",
"ZNRF3-AS1",
"ZPR1",
"ZRANB1",
"ZRANB2-AS2",
"ZSCAN12P1",
"ZSCAN16",
"ZSCAN16-AS1",
"ZSCAN20",
"ZSCAN25",
"ZSCAN31",
"ZSCAN32",
"ZSWIM4",
"ZW10",
"ZWINT",
"ZXDB",
"ZZZ3"
];

export default AllGeneList;